
var guardScreenCheckinSpreadsheet = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null];

var guardScreenCheckinSpreadsheetColumns = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null];
var guardScreenCheckinSpreadsheetElementRoot = 'guardScreenSpreadsheet';
var guardScreenCheckinSpreadsheetOnChangeDisabled = false;



function GuardScreenClearSpreadsheets() {
    guardScreenCheckinSpreadsheet = [];
    return 1;
}

var guardScreenCheckinSpreadsheetReceiverUnitColumnIndex = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
var guardScreenCheckinSpreadsheetAutoAdmitNameColumnIndex = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
var guardScreenCheckinSpreadsheetReceiverNameColumnIndex = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
var guardScreenCheckinSpreadsheetVendorNameColumnIndex = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
var guardScreenCheckinSpreadsheetPlateNumberColumnIndex = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
var guardScreenCheckinSpreadsheetColumnCount = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];

var autoAdmitPersonAutoAdmitTypeEnum = 0;

var lastLookedUpAutoAdmitList;

var defaultVendorsDropdown = ["Private Landscaper", "Private Contractor", "Realtor", "Food/Water Delivery", "Transportation", "\"123\"", "In-house vendor", "Dry Cleaners", "Floral Delivery", "Dog Groomer", "Pet Care", "Pest Control", "Other"];


var GuardScreenCreateCheckedInSpreadsheetCallCount = 0;


var guardScreenCurrentSelectedTab = 1;
var DefaultCellSelected = false;
var FirstCellMoved = false;
var oldSelectedRow;
var oldSelectedCol;
function SetCurrentTab(currentTab) {
    guardScreenCurrentSelectedTab = currentTab;
}

function UpdateScroll(JexcelContainer) {
    JexcelContainer.updateScroll();
    var sRow = Number(JexcelContainer.getSelectedRows(true)[0]);
    var sCol = Number(JexcelContainer.getSelectedColumns(true)[0]);
    var ColCount = JexcelContainer.colgroup.length;
    var RowCount = JexcelContainer.rows.length;
    if (sRow == 1) {
        setTimeout(function () { $(JexcelContainer.content).scrollTop(0) }, 200);
    }
    if (sRow == RowCount - 1) {
        setTimeout(function () { $(JexcelContainer.content).scrollTop($(JexcelContainer.el).height()) }, 200);
    }
    if (sCol == 2) {
        setTimeout(function () { $(JexcelContainer.content).scrollLeft(0) }, 200);
    }
    if (sCol == ColCount - 2) {
        setTimeout(function () { $(JexcelContainer.content).scrollLeft($(JexcelContainer.el).width()) }, 200);
    }
}
function MoveToCell(Row, Col, FromJexcel) {
    //finish preventing running outside the grid
    var focusedElement = $(':focus');
    if (DefaultCellSelected) {
        var JexcelContainer = guardScreenCheckinSpreadsheet[guardScreenCurrentSelectedTab - 1];
        var ColCount = JexcelContainer.colgroup.length;
        var RowCount = JexcelContainer.rows.length;
        if (JexcelContainer) {
            if (FromJexcel) {
                JexcelContainer.updateSelectionFromCoords(Col, Row, Col, Row);
            } else {
                if (focusedElement.attr("class") != "jexcel_container") { //to prevent  double move due to the default jexcel navigation
                    var sRow = Number(JexcelContainer.getSelectedRows(true)[0]);
                    var sCol = Number(JexcelContainer.getSelectedColumns(true)[0]);


                    if (isNaN(sRow) || isNaN(sCol)) {
                        sRow = 0;
                        sCol = 2;
                        Row = 0;
                        Col = 0;
                    }
                    oldSelectedRow = sRow;
                    oldSelectedCol = sCol;
                    sRow += Row;
                    sCol += Col;
                    JexcelContainer.updateSelectionFromCoords(sCol, sRow, sCol, sRow);
                    if (sCol == 1 && FirstCellMoved) {
                        JexcelContainer.updateSelectionFromCoords(oldSelectedCol, oldSelectedRow, oldSelectedCol, oldSelectedRow);
                    }
                    if (sCol == (ColCount - 1) && FirstCellMoved) {
                        JexcelContainer.updateSelectionFromCoords(oldSelectedCol, oldSelectedRow, oldSelectedCol, oldSelectedRow);
                    }
                    if (sRow == RowCount && FirstCellMoved) {
                        JexcelContainer.updateSelectionFromCoords(oldSelectedCol, oldSelectedRow, oldSelectedCol, oldSelectedRow);
                    }
                }
                else {

                }
            }
            UpdateScroll(JexcelContainer);
            FirstCellMoved = true;
        }

    } else {

    }

}
$(document).keydown(function (event) {
    var focusedElement = $(':focus');
    if (focusedElement.attr("class") == "jexcel_container") {
        switch (event.which) {
            case 37: // Left arrow key
                MoveToCell(0, -1, false);
                event.preventDefault();
                break;
            case 38: // Up arrow key
                MoveToCell(-1, 0, false);
                event.preventDefault();
                break;
            case 39: // Right arrow key
                MoveToCell(0, 1, false);
                event.preventDefault();
                break;
            case 40: // Down arrow key
                MoveToCell(1, 0, false);
                event.preventDefault();
                break;
            default:
                break; // Do nothing for other keys
        }


        if (event.which == 9) { // 9 is the keycode for the TAB key

            event.preventDefault();
        }
    }
});


function GuardScreenCreateCheckedInSpreadsheet(gridIndex, siteType, dateFormat, requiredInputs, checkoutRequired, checkinPaginationSize, allowMoveColumns, layoutNumber, locale, allowColumnRename, showIndex, evenRowsColor, requireCallAlert, vendorTypes, kiosk, hiddenUnitColumn, showOpenGateCheckbox) {
    try {
        var vendorTypesAdded = 0;
        var vendorTypesToDisplay = defaultVendorsDropdown;
        if (vendorTypes != null) {
            vendorTypesToDisplay = [];

            var vendorTypesCount = vendorTypes.length;
            for (var vx = 0; vx < vendorTypesCount; vx++) {
                vendorTypesToDisplay.push(vendorTypes[vx].vendorTypeName);
                vendorTypesAdded++;
            }
        }
        if (vendorTypesAdded == 0) {
            vendorTypesToDisplay = defaultVendorsDropdown;
        }
    } catch (e) {
        console.log(e);
    }

    if (kiosk) {
        $('.jexcel_filter').css('display', 'none');
    }

    residentNameDropdown = async function (instance, cell, c, r, source) {
        var personsNameList = [];

        //  console.log("guardScreenPersonNameListCache");
        //  console.log(guardScreenPersonNameListCache);
        //TODO, dont fetch everytime this dropdown is opened?

        //guardScreenPersonNameListCache = personCacheGetAllResidents();

        var allPersonsPromise = DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'GetAllPersonsFromGrid')
            .then(r => {
                return r;
            });

        var personNames = await allPersonsPromise;

        // console.log("guardScreenPersonNameListCache");
        // console.log(guardScreenPersonNameListCache);

        for (var i = 0; i < columnCount; i++) {
            if ((guardScreenCheckinSpreadsheetColumns[gridIndex][i].name).indexOf("ReceiverUnit") >= 0) {
                var columnX = i;
                var unit = guardScreenCheckinSpreadsheet[gridIndex].getRowData(r)[columnX];

                if (isEmptyOrSpaces(unit)) {
                    return personNames;
                }

                var allPersonsForUnitPromise = DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'GetAllPersonsForUnitFromGrid', unit)
                    .then(r => {
                        return r;
                    });

                personsNameList = await allPersonsForUnitPromise;

                //if (receiversWithResidentsCache != null) {
                //    receiversWithResidentsCacheLength = receiversWithResidentsCache.length;
                //    for (var rx = 0; rx < receiversWithResidentsCacheLength; rx++) {
                //        if (receiversWithResidentsCache[rx].receiverUnit == unit) {

                //            if (receiversWithResidentsCache[rx].residents != null) {
                //                var personCount = receiversWithResidentsCache[rx].residents.length;
                //                for (var px = 0; px < personCount; px++) {
                //                    personsNameList.push(receiversWithResidentsCache[rx].residents[px].personName);
                //                }
                //            }

                //            break;
                //        }
                //    }
                //}
            }
        }

        try {
            personsNameList = personsNameList.sort();
        } catch (e) {
        }

        return personsNameList;
    }

    autoAdmitDropdown = async function (instance, cell, c, r, source) {
        // Get a value from the same row but previous column
        // var value = $(instance).jexcel('getValue', c - 1 + '-' + r);
        var value = 1;

        var autoAdmitsForReceiver = [];
        lastLookedUpAutoAdmitList = [];

        var ownColumnName = guardScreenCheckinSpreadsheetColumns[gridIndex][c].name;

        for (var i = 0; i < columnCount; i++) {
            // Find columns in grid that we can update with Receiver lookup data
            if ((guardScreenCheckinSpreadsheetColumns[gridIndex][i].name).indexOf("ReceiverUnit") >= 0) {
                var columnX = i;

                var unit = guardScreenCheckinSpreadsheet[gridIndex].getRowData(r)[columnX];

                var promise = DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'GetAutoAdmitListForReceiverFromGrid', gridIndex, unit)
                    .then(r => {
                        return r;
                    });

                autoAdmitsForReceiver = await promise; // wait till the promise resolves (*)

                //autoAdmitsForReceiver = DotNet.invokeMethod('VisitForm.Client.UI.Guard', 'GetAutoAdmitListForReceiverFromGrid', gridIndex, unit);
            }
        }

        var promiseLastAutoAdmitList = DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'GetLastLookedUpAutoAdmitListFromGrid')
            .then(r => {
                return r;
            });

        var lastLookedUpAutoAdmitListStr = await promiseLastAutoAdmitList; // wait till the promise resolves (*)


        //var lastLookedUpAutoAdmitListStr = DotNet.invokeMethod('VisitForm.Client.UI.Guard', 'GetLastLookedUpAutoAdmitListFromGrid')
        try {
            lastLookedUpAutoAdmitList = JSON.parse(lastLookedUpAutoAdmitListStr);
        }
        catch { }


        return autoAdmitsForReceiver;
    }

    //Use filter in order receiverCache is updated during runtime
    receiverUnitDropdown = async function (instance, cell, c, r, source) {
        var temp = [];

        temp = DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'GetAllUnitsFromGrid');

        return temp;
    }

    var shouldShowRequireCallAlert = requireCallAlert;

    var guardScreenCheckinSpreadsheetElement = guardScreenCheckinSpreadsheetElementRoot + gridIndex;

    $("#" + guardScreenCheckinSpreadsheetElement).append("<button style='display:none' id='JexcelFocusButton" + gridIndex + "'>focus</button>");
    var localeData = null;

    try {
        localeData = JSON.parse(locale);
    } catch (e) {

    }

    var generalColumnWidth = 200;

    if (requiredInputs != null && requiredInputs.length <= 5) {
        generalColumnWidth = 400;
    }

    guardScreenCheckinSpreadsheetColumns[gridIndex] = [];

    //Variables to keep track of certain columns in order to change their HTML/CSS
    var plateNumberColumnIndex = -1;
    var visitNumberColumnIndex = -1;
    var receiverUnitColumnIndex = -1;
    var receiverNameColumnIndex = -1;
    var autoAdmitColumnIndex = -1;
    var vendorNameColumnIndex = -1;
    var expectedCheckoutColumnIndex = -1;
    var columnIndexCounter = 0;

    guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'hidden', title: 'CheckinId', width: 0, name: ' ' })
    columnIndexCounter++;

    var columnSeperatorIndices = [];

    requiredInputs.forEach(function (arg) {
        if (arg.id != "CheckinId") {

            if (arg.id == "ColumnSeparator") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '2', title: '', name: arg.id, readOnly: true });
                columnSeperatorIndices.push(columnIndexCounter);
            }
            else if (arg.id == "ReceiverName" || arg.id == "ReceiverUnit" || arg.id == "ReceiverPhonenumber" || arg.id == "ReceiverPhonenumber2" || arg.id == "ReceiverPhonenumber3" || arg.id == "ReceiverEmail") {

                var temp = [];

                if (arg.id == "ReceiverName") {
                    // guardScreenPersonNameListCache = personCacheGetAllResidents();

                    //var allPersonsPromise = DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'GetAllPersonsFromGrid')
                    //    .then(r => {
                    //        return r;
                    //    });

                    //var personNames = await allPersonsPromise; 
                }
                else {
                    //var receiversInCacheCount = receiversCache.length;
                    //for (var i = 0; i < receiversInCacheCount; i++) {

                    //    var propertyName = minimizeFirstLetter(arg.id);
                    //    var rowValue = receiversCache[i][propertyName];
                    //    if (isEmptyOrSpaces(rowValue) == false) {
                    //        temp.push(rowValue);
                    //    }
                    //}
                }


                var columnHeaderTitle = getColumnName(arg); //arg.friendlyName;
                //If site is not gated community
                if (siteType == 1) {
                    columnHeaderTitle = columnHeaderTitle.replace("Resident", "Host");
                }

                var isReadOnly = false;


                if (arg.id == "ReceiverName") {

                    guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'dropdown', width: '200', source: temp, autocomplete: true, multiple: false, title: columnHeaderTitle, name: arg.id, filter: residentNameDropdown })

                }
                else if (arg.id == "ReceiverPhonenumber" || arg.id == "ReceiverPhonenumber2" || arg.id == "ReceiverPhonenumber3") {
                    guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'dropdown', width: '200', source: temp, autocomplete: true, multiple: false, title: columnHeaderTitle, name: arg.id, readOnly: true })

                }
                else if (arg.id == "ReceiverEmail") {
                    guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'dropdown', width: '200', source: temp, autocomplete: true, multiple: false, title: columnHeaderTitle, name: arg.id, readOnly: true })

                }
                else {
                    var unitColumnType = hiddenUnitColumn ? "hidden" : "dropdown";
                    guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: unitColumnType, width: '200', source: temp, autocomplete: true, lazyLoading: true, multiple: false, title: columnHeaderTitle, name: arg.id, filter: receiverUnitDropdown, readOnly: false })
                }
                //guardScreenCheckinSpreadsheetColumns[gridIndex].push({ editor: createCustomDropdown(temp), autocomplete: false, type: 'text' , width: '200', title: arg.friendlyName, name: arg.id })

                if (arg.id == "ReceiverUnit") {
                    receiverUnitColumnIndex = columnIndexCounter;
                }

                if (arg.id == "ReceiverName") {
                    receiverNameColumnIndex = columnIndexCounter;
                }
            }
            else if (arg.id == "ReceiverRequireCall") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '110', title: getColumnName(arg), name: arg.id, readOnly: true });
            }
            else if (arg.id == "VisitorIdentificationVerified") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'checkbox', width: '80', title: getColumnName(arg), name: arg.id, readOnly: false }); //Use hardcoded smaller text for header
            }
            else if (arg.id == "VisitorIsParcelDelivery") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'checkbox', width: '75', title: getColumnName(arg), name: arg.id });  //Use hardcoded smaller text for header
            }
            else if (arg.id == "VisitNotified") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'checkbox', width: '75', title: getColumnName(arg), name: arg.id });
            }
            else if (arg.id == "VisitorIsGuest") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'checkbox', width: '75', title: getColumnName(arg), name: arg.id });
            }
            else if (arg.id == "VisitorVirusChecked") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'checkbox', width: '100', title: getColumnName(arg), name: arg.id });
            }
            else if (arg.id == "VisitorHealthChecked") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'checkbox', width: '90', title: getColumnName(arg), name: arg.id });
            }
            else if (arg.id == "RentalCheckin") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'checkbox', width: '90', title: getColumnName(arg), name: arg.id });
            }
            else if (arg.id == "VisitorCalledAhead") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'checkbox', width: '100', title: getColumnName(arg), name: arg.id });
            }
            else if (arg.id == "VisitorTurnedAway") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'checkbox', width: '110', title: getColumnName(arg), name: arg.id });
            }
            else if (arg.id == "VisitNumber") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '100', title: getColumnName(arg), name: arg.id, readOnly: true });
                visitNumberColumnIndex = columnIndexCounter;
            }
            else if (arg.id == "VisitorPhonenumber") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '100', title: getColumnName(arg), name: arg.id, });
            }
            else if (arg.id == "VisitorExtra") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '200', title: getColumnName(arg), name: arg.id, wordWrap: true });
            }
            else if (arg.id == "VisitorVehicleRegistrationPlate") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '200', title: getColumnName(arg), name: arg.id });
                plateNumberColumnIndex = columnIndexCounter;
            }
            else if (arg.id == "CheckinTimestamp") {

                var title = getColumnName(arg);

                //If this is a precheckin table, we show time until arrival instead
                if (gridIndex == 2 || gridIndex == 3 || gridIndex == 7 || gridIndex == 9) {
                    title = "Time Until Arrival";
                }
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '200', title: title, name: arg.id });
            }
            else if (arg.id == "VisitorTemporaryStartTime" || arg.id == "VisitorTemporaryEndTime") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' }, width: '150', title: getColumnName(arg), name: arg.id });
            }
            else if (arg.id == "ExpectedCheckinTimestamp") {
                //Checkout grids
                if (gridIndex == 10 || gridIndex == 11 || gridIndex == 14) {
                    guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '200', title: getColumnName(arg), name: arg.id });
                }
                else {
                    guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY HH24:MI' : 'MM/DD/YYYY HH12:MI AM/PM', time: 1 }, width: '200', title: getColumnName(arg), name: arg.id });
                }
            }
            else if (arg.id == "ExpectedCheckoutTimestamp") {
                if (gridIndex == 10 || gridIndex == 11 || gridIndex == 14) {
                    guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '200', title: getColumnName(arg), name: arg.id });
                }
                else {
                    guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY HH24:MI' : 'MM/DD/YYYY HH12:MI AM/PM', time: 1 }, width: '200', title: getColumnName(arg), name: arg.id });
                }
                expectedCheckoutColumnIndex = columnIndexCounter;
            }
            else if (arg.id == "AutoAdmitDue") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'dropdown', width: '120', title: getColumnName(arg), name: arg.id, source: ['Temporary', 'Permanent'], multiple: false, readOnly: true });
            }
            //else if (arg.id == "AutoAdmitDueFrom" || arg.id == "AutoAdmitDueTo") {
            //    guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'calendar', options: { format: dateFormat == 0 ? 'DD/MM/YYYY' : 'MM/DD/YYYY' }, width: '150', title: getColumnName(arg), name: arg.id, readOnly: true });
            //}
            else if (arg.id == "AutoAdmitDueFrom" || arg.id == "AutoAdmitDueTo") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '170', title: getColumnName(arg), name: arg.id, readOnly: true });
            }
            else if (arg.id == "AutoAdmitName") {

                autoAdmitColumnIndex = columnIndexCounter;

                var nameType = "dropdown";
                if (kiosk) {
                    nameType = "text";
                }
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: nameType, width: '200', title: getColumnName(arg), name: arg.id, allowEmptyValues: true, source: ['TestAutoAdmit1', 'TestAutoAdmit2'], multiple: false, autocomplete: true, filter: autoAdmitDropdown });
            }
            else if (arg.id == "AutoAdmitBanned") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '120', title: getColumnName(arg), name: arg.id, readOnly: true });
            }
            else if (arg.id == "AutoAdmitIdentification" || arg.id == "AutoAdmitDriverLicense" || arg.id == "AutoAdmitRepresentative" || arg.id == "AutoAdmitPlateNumber") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: '140', title: getColumnName(arg), name: arg.id, readOnly: false });
            }
            else if (arg.id == "VisitorIsTemporary") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'checkbox', width: '100', title: getColumnName(arg), name: arg.id, readOnly: true });
            }
            else if (arg.id == "VisitNotificationType") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'dropdown', width: '130', title: getColumnName(arg), name: arg.id, source: ['Automatic', 'Call', 'Email', 'Text', ' '], multiple: true });
            }
            else if (arg.id == "VisitTypeCategoryName") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'dropdown', width: '180', title: getColumnName(arg), name: arg.id, source: ['Police', 'Fire Truck', 'Ambulance', 'Power Outage', 'Paramedics', 'Information', 'House Alarm', 'Fire Alarm', 'Stranger', 'Burglar Alarm', 'Vandalism', 'Other Alarm', 'Other'], multiple: true });
            }
            else if (arg.id == "VendorName") {

                var tempVendors = [];

                var vendorsInCacheCount = vendorsCache.length;
                for (var i = 0; i < vendorsInCacheCount; i++) {

                    tempVendors.push(vendorsCache[i].vendorName);
                }

                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'dropdown', width: '200', allowEmptyValues: true, title: getColumnName(arg), name: arg.id, source: tempVendors, autocomplete: true, multiple: false });

                vendorNameColumnIndex = columnIndexCounter;
            }
            else if (arg.id == "VendorType") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'dropdown', width: '140', allowEmptyValues: true, title: getColumnName(arg), name: arg.id, source: vendorTypesToDisplay, autocomplete: true, multiple: false });
            }
            else if (arg.id == "VendorInsuranceRequired" || arg.id == "VendorInsuranceOnFile") {
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'checkbox', width: '140', title: getColumnName(arg), name: arg.id, readOnly: true });
            }

            else { // All standard
                guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', width: generalColumnWidth, title: getColumnName(arg), name: arg.id });
            }

            columnIndexCounter++;
        }
    });

    var columnCount = guardScreenCheckinSpreadsheetColumns[gridIndex].length;

    guardScreenCheckinSpreadsheetColumns[gridIndex].push({ type: 'text', title: ' ', width: 200 })

    if (gridIndex == 4 || gridIndex == 8 || gridIndex == 9 || gridIndex == 10 || gridIndex == 11 || gridIndex == 14 || gridIndex == 18) {
        for (var j = 0; j < columnCount; j++) {
            guardScreenCheckinSpreadsheetColumns[gridIndex].readOnly = true;
        }
    }

    guardScreenCheckinSpreadsheetColumnCount[gridIndex] = columnCount;

    //var tableHeight = window.innerHeight / 2;

    //  alert("window.innerHeight: " + window.innerHeight);

    var tableHeight = window.innerHeight - (45 + 15 + 100 + 100 + 45) - 100;

    // alert("tableHeight: " + tableHeight);
    if (tableHeight < 256) {
        tableHeight = 256;
    }

    //Store indices to use to check speech input etc..
    guardScreenCheckinSpreadsheetReceiverUnitColumnIndex[gridIndex] = receiverUnitColumnIndex;
    guardScreenCheckinSpreadsheetAutoAdmitNameColumnIndex[gridIndex] = autoAdmitColumnIndex;
    guardScreenCheckinSpreadsheetReceiverNameColumnIndex[gridIndex] = receiverNameColumnIndex;
    guardScreenCheckinSpreadsheetVendorNameColumnIndex[gridIndex] = vendorNameColumnIndex;
    guardScreenCheckinSpreadsheetPlateNumberColumnIndex = plateNumberColumnIndex;

    var tempGrid = jexcel(document.getElementById(guardScreenCheckinSpreadsheetElement), {
        data: null,
        //contextMenu: false,
        columns: guardScreenCheckinSpreadsheetColumns[gridIndex],
        allowRenameColumn: kiosk ? false : allowColumnRename,
        allowManualInsertRow: false,
        allowManualInsertColumn: false,
        allowInsertColumn: false,
        //  allowDeleteRow: false, //Cant use this since this also invalidates programmaticaly deletion of rows...
        allowDeleteColumn: false,
        //  width: 100,
        search: true,
        lazyLoading: true,
        loadingSpin: true,
        //  freezeColumns: 1,
        tableWidth: '100%',
        lazyLoading: true,
        //tableHeight: "100%",
        tableHeight: tableHeight + 'px',
        rowResize: true,
        columnSorting: false,
        tableOverflow: true,
        columnDrag: kiosk ? false : allowMoveColumns,

        /*freezeColumns: 2,*/
        freezeRightColumn: true,
        freezeLeftColumn: true,
        onload: function (instance) {


            if (!showIndex) {
                $($(instance).find('table')).each(function (i, obj) {
                    $(obj).addClass('jexcel_hidden_index');
                });
            }

            var separatorCount = columnSeperatorIndices.length;
            for (var sx = 0; sx < separatorCount; sx++) {
                $($(instance).find('td[data-x="' + columnSeperatorIndices[sx] + '"]')).each(function (i, obj) {
                    $(obj).css("background-color", "#ccc");
                });
            }

            $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                $(obj).css("background-color", "#f3f3f3");
            });

            $($(instance).find('td[data-x="' + columnCount + '"]')).each(function (i, obj) {
                $(obj).css("background-color", "#f3f3f3");
            });

            //Remove bugged undefined tooltip
            $($(instance).find('td')).each(function (i, obj) {
                $(obj).attr("title", "");
            });

            $($(instance).find('tr')).each(function (i, obj) {
                if (i != 0 && i != 1) {
                    $(obj).addClass("guard-screen-grid-hover-row");
                }

            });


            if (evenRowsColor != "empty") {

                $($(instance).find('tr:even')).each(function (i, obj) {
                    if (i != 0) {
                        $(obj).css("background-color", evenRowsColor);
                    }

                });

                $($(instance).find('tr:odd')).each(function (i, obj) {
                    if (i != 0) {
                        $(obj).css("background-color", '#fff');
                    }

                });
            }



            //This finds all rows with columnCount, which is equal to the last column of the grid
            $($(instance).find('td[data-x="' + columnCount + '"][data-y]')).each(function (i, obj) {

                //console.log($(obj).parent().children().eq(1).html());
                //checkinId stored in hidden column with index 0
                // var checkinId = parseInt($(instance).find('td[data-x="0"][data-y="' + i + '"]').html());
                var checkinId = parseInt($(obj).parent().children().eq(1).html()); // Get second column that contains checkinId, first col (0) is index number

                if (Number.isNaN(checkinId)) {
                    checkinId = 0;
                }

                //checkinTimestamp always stored in column 1
                //var checkinTimestamp = $(instance).find('td[data-x="1"][data-y="' + i + '"]').html();
                var checkinTimestamp = $(obj).parent().children().eq(2).html();

                //only used to set height of first row
                if (i == 0 && !(gridIndex >= 10 && gridIndex <= 20)) {
                    // $(obj).html('<div style=\"height:36px;background-color:transperent;vertical-align:middle;line-height:36px;\"></div>');
                    var checkinButtonLocale = 'Check In';
                    try {
                        //checkinButtonLocale = localeData.CheckInButton;
                        checkinButtonLocale = 'Check In';
                    } catch (e) {
                        checkinButtonLocale = 'Check In';
                    }

                    if (gridIndex == 2 || gridIndex == 3 || gridIndex == 7) {
                        checkinButtonLocale = "Register";
                    }

                    if (gridIndex == 4) {
                        checkinButtonLocale = "Check In";
                    }

                    if (gridIndex == 5) {
                        checkinButtonLocale = "Log";
                    }

                    var btnClass = "btn-primary";

                    if (gridIndex == 2 || gridIndex == 3 || gridIndex == 7 || gridIndex == 9) {
                        btnClass = "btn-info";
                    }

                    if (gridIndex != 9) {
                        $(obj).html('<button id=\"guardScreenGridCheckinButton' + gridIndex + '\" onclick=\"checkInFromGrid(' + gridIndex + ", " + checkinId + ')\" type=\"button\" class=\"btn ' + btnClass + '\">&nbsp;&nbsp;' + checkinButtonLocale + '&nbsp;&nbsp;</button>');
                        $(obj).css("background-color", "#F3F3F3");
                    }

                }

                var startRowY = 0;
                if (gridIndex == 8 || gridIndex == 9) {
                    startRowY = -1;
                }

                //Only checkout button for visitors, vendors and receivers for now
                if ((gridIndex == 0 || gridIndex == 1 || gridIndex == 4 || gridIndex == 8)) {
                    if (i > startRowY) {
                        var checkoutButtonLocale = 'Check Out';
                        try {
                            //checkoutButtonLocale = localeData.CheckOutButton;
                            checkoutButtonLocale = 'Check Out';
                        } catch (e) {
                            checkoutButtonLocale = 'Check Out';
                        }

                        if (gridIndex == 8) {
                            checkoutButtonLocale = 'Depart';
                        }


                        var buttonDiv = '<div style=\"display:inline-block;width:100%;display:flex;flex-direction:row;align-content:center;justify-content:center;align-items:center;\">';

                        var buttonRow = '';

                        if (checkoutRequired) {
                            buttonRow += '<button onclick=\"checkOutFromGrid(' + gridIndex + ',' + checkinId + ',\'' + checkinTimestamp + '\')\" type=\"button\" class=\"btn btn-success\">' + checkoutButtonLocale + '</button>';
                            buttonRow += '&nbsp;';
                        }

                        if (!kiosk) {
                            buttonRow += '<button onclick=\"checkinDetailsFromGrid(' + gridIndex + ',' + checkinId + ',\'' + checkinTimestamp + '\')\" type=\"button\" class=\"btn-sm btn-secondary\">' + 'Details' + '</button>';

                        }


                        buttonDiv += buttonRow;

                        buttonDiv += '</div>';

                        $(obj).html(buttonDiv);

                    }
                }


                if (gridIndex == 2 || gridIndex == 3 || gridIndex == 7 || gridIndex == 9) {


                    if (i > startRowY) {
                        var admitButtonLocale = 'Check In';
                        var admitButtonStyleClass = "btn-primary";
                        try {
                            // admitButtonLocale = localeData.CheckOutButton;
                        } catch (e) {
                            //checkoutButtonLocale = 'Check out';
                        }

                        if (gridIndex == 9) {
                            admitButtonLocale = 'Arrived';
                            admitButtonStyleClass = "btn-primary";
                        }

                        //if (gridIndex == 8) {
                        //    admitButtonLocale = 'Depart';
                        //    admitButtonStyleClass = "btn-success";
                        //}

                        var showPreCheckingButtonLocale = 'Details';


                        var admitButton = '<button onclick=\"admitPreCheckinFromGrid(' + gridIndex + ',' + checkinId + ',\'' + checkinTimestamp + '\')\" type=\"button\" class=\"screenadmitbtn btn ' + admitButtonStyleClass + '\">' + admitButtonLocale + '</button>';

                        //Lease grid
                        if (gridIndex == 8 || gridIndex == 9) {
                            var deleteButton = '<button  onclick=\"showPreCheckinDetailsFromGrid(' + checkinId + ',\'' + checkinTimestamp + '\')\" type=\"button\" class=\"btn btn-info\">' + 'Info' + '</button>';
                        }
                        else {
                            var deleteButton = '<button  onclick=\"showPreCheckinFromGrid(' + checkinId + ',\'' + checkinTimestamp + '\')\" type=\"button\" class=\"btn btn-sm btn-secondary\">' + showPreCheckingButtonLocale + '</button>';


                        }

                        var autoAdmitButtonDiv = '<div style=\"display:inline-block;width:100%;display:flex;flex-direction:row;align-content:center;justify-content:center;align-items:center;\">';
                        autoAdmitButtonDiv += admitButton + '&nbsp;' + deleteButton;
                        autoAdmitButtonDiv += '</div>';

                        $(obj).html(autoAdmitButtonDiv);

                    }
                }



            });

            //Iterate through the first column to change first to New Visitor arrow
            $($(instance).find('td[data-x="1"][data-y]')).each(function (i, obj) {

                if (i == 0 && !(gridIndex >= 10 && gridIndex <= 20)) {
                    // $(obj).html('<div style=\"height:36px;background-color:transperent;vertical-align:middle;line-height:36px;\"><span><i class=\"fas fa-chevron-right\"></i></span></div>');


                    var newVisitorText = 'New Visitor';
                    if (gridIndex == 1) {
                        newVisitorText = 'New Vendor';
                    }
                    else if (gridIndex == 2) {
                        newVisitorText = 'Pre-Register Visitor';
                    }
                    else if (gridIndex == 3) {
                        newVisitorText = 'Pre-Register Vendor';
                    }
                    else if (gridIndex == 4) {
                        newVisitorText = 'Resident';
                    }
                    else if (gridIndex == 5) {
                        newVisitorText = 'New Event';
                    }
                    else if (gridIndex == 7) {
                        newVisitorText = 'Pre-Register Resident';
                    }

                    try {
                        newVisitorText = 'New Visitor';
                        if (gridIndex == 1) {
                            newVisitorText = 'New Vendor';
                        }
                        else if (gridIndex == 2) {
                            newVisitorText = 'Pre-Register Visitor';
                        }
                        else if (gridIndex == 3) {
                            newVisitorText = 'Pre-Register Vendor';
                        }
                        else if (gridIndex == 4) {
                            newVisitorText = 'Resident';
                        }
                        else if (gridIndex == 5) {
                            newVisitorText = 'New Event';
                        }
                        else if (gridIndex == 7) {
                            newVisitorText = 'Pre-Register Resident';
                        }

                    } catch (e) {
                        newVisitorText = 'New Visitor';
                        if (gridIndex == 1) {
                            newVisitorText = 'New Vendor';
                        }
                        else if (gridIndex == 2 || gridIndex == 3) {
                            newVisitorText = 'Pre-Register visitor';
                        }
                        else if (gridIndex == 4) {
                            newVisitorText = 'New Event';
                        }
                    }

                    var newVisitorArrowHtml = '<div onclick=\"clearGridFirstRow(' + gridIndex + ', false);\" id=\"newVisitorArrow' + gridIndex + '\" style=\"height:36px;background-color:transperent;z-index:1;display:flex;flex-direction:column;padding-top:5px;overflow:hidden;max-width:100%;\"><span>' + newVisitorText + '&nbsp;&nbsp;<i class=\"fas fa-arrow-right\"></i></span><span style=\"display:block;font-size:80%;\">(click to clear row)</span></div>';
                    newVisitorArrowHtml += '<div id=\"newVisitorArrowLoading' + gridIndex + '\" class=\"spinner-grow text-secondary\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>';

                    //$(obj).html('<div style=\"height:36px;background-color:transperent;vertical-align:middle;line-height:36px;\"><span>New visitor &nbsp;&nbsp;<i class=\"fas fa-arrow-right\"></i></span></div>');

                    if (!(gridIndex == 8 || gridIndex == 9)) {
                        $(obj).html(newVisitorArrowHtml);
                        $(obj).css("background-color", "#F3F3F3");
                    }

                }
            });


            ////Iterate thrught the first row
            $($(instance).find('td[data-x][data-y="0"]')).each(function (i, obj) {

                //Mark VisitNumber column gray to indicate not to fill in 
                if (visitNumberColumnIndex > 0 && i == visitNumberColumnIndex) {
                    $(obj).css("background-color", "#F3F3F3");
                }

                if (plateNumberColumnIndex > 0 && i == plateNumberColumnIndex) {
                    //   $(obj).css("text-transform", "uppercase");
                    $(obj).addClass("uppercase-typing");
                }

                //trick to have residents grid read only except for first row
                if (gridIndex == 4) {
                    $(obj).removeClass("readonly");

                }

            });

            $(".jexcel_search").css({ "border": "1px solid #ccc" });
            $(".jexcel_search").css({ "font-size": "120%" });
            $(".jexcel_search").css({ "margin-top": "20px" });


            var searchLocaleTitle = 'Search';

            $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                ////Move title and header div inside of the filter div to remove the space
                $(obj).prepend($("#guardscreen-header-checkin-title" + gridIndex));
            });


            changeNotesBoxLocation(layoutNumber);

            //Should be moved to other function
            try {
                setTimeout(function () {
                    autosize($('#innerNotesSection textarea'));
                }, 5000);
            } catch (e) {

            }

            try {
                if (gridIndex == 0) {
                    $($(instance).find('td[data-x="' + columnCount + '"]')).each(function (i, obj) {
                        if (i == 0) {
                            var defaultOpenGateChecked = true;
                            $(obj).html('<div id="openGateCheckDiv' + gridIndex + '" class="openGateCheck" style="display:' + (showOpenGateCheckbox ? 'flex' : 'none') + ';align-items:center;align-content:center;justify-content:center;"><input type="checkbox" id="checkinGridOpenGate' + gridIndex + '" name="checkinGridOpenGate' + gridIndex + '" style="margin-right:5px;" ' + (defaultOpenGateChecked ? 'checked' : '') + ' /><label style="margin-bottom:0px;" for="checkinGridOpenGate' + gridIndex + '">Open Gate</span></div>');
                        }
                    });
                }
            }
            catch (e) {
            }

            try {

                for (var cx = 1; cx < columnCount; cx++) {
                    $($(instance).find('td[data-x="' + cx + '"]')).each(function (i, obj) {
                        if (i == 0) {

                            if (i == 0) {

                                var title = $(obj).text()

                                //  

                                var cid = guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name;

                                var tooltipText = '';

                                if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("Receiver") >= 0) {

                                    if (siteType == 0) {
                                        $(obj).html('<i class="fas fa-home text-info" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');

                                        if (cid == "ReceiverUnit") {
                                            tooltipText = 'Select resident';
                                        }

                                        tooltipText = "Resident related information";
                                    }
                                    else {
                                        $(obj).html('<i class="fas fa-user-tie text-info" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');

                                        if (cid == "ReceiverUnit") {
                                            tooltipText = 'Select host';
                                        }

                                        tooltipText = "Host related information";
                                    }

                                }
                                else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("VisitNotified") >= 0) {



                                    if (siteType == 0) {
                                        $(obj).html('<i class="fas fa-home text-info" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Check this if the resident has been notified and has acknowledged the visit. If automatic notification is used, a notification will be sent to the resident automatically if opted. This column does not auto-fill";
                                    }
                                    else {
                                        $(obj).html('<i class="fas fa-user-tie text-info" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Check this if the host has been notified and has acknowledged the visit. If automatic notification is used, a notification will be sent to the host automatically if opted. This column does not auto-fill";
                                    }



                                }
                                else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("Parcel") >= 0) {

                                    $(obj).html('<i class="fas fa-box text-warning" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');


                                    tooltipText = "Parcel Related Information";

                                }
                                else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("Custom") >= 0) {

                                    $(obj).html('<i class="fas fa-list" style="font-size:100%;padding-right:5px;color:#333;"></i><span>' + title + '</span>');

                                    tooltipText = "Custom Data";

                                }
                                else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("AutoAdmit") >= 0) {



                                    if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("AutoAdmitName") >= 0) {
                                        $(obj).html('<i class="fas fa-user text-success" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Visitor Name. Auto fills other columns if an Auto-Admit Name is selected from the dropdown list.";
                                    }
                                    else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("AutoAdmitPlateNumber") >= 0) {
                                        $(obj).html('<i class="fas fa-hashtag text-success" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Visitor Information. Auto fills if an auto-admit Name is selected.";
                                    }
                                    else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("AutoAdmitBanned") >= 0) {
                                        $(obj).html('<i class="fas fa-user text-success" style="font-size:100%;padding-right:5px;"></i><i class="fas fa-question text-success" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Read-Only Allowed or Banned, this field shows if the selected person in the Auto-Admit Name column is allowed or banned from the premises";
                                    }
                                    else {
                                        $(obj).html('<i class="fas fa-user text-success" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Visitor Information. Auto fills if an auto-admit Name is selected.";
                                    }


                                }
                                else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("Visitor") >= 0) {

                                    if (cid.indexOf("Vehicle") >= 0) {
                                        $(obj).html('<i class="fas fa-car-alt text-secondary" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = 'Vehicle registration plate';
                                    }
                                    else if (cid.indexOf("TurnedAway") >= 0) {
                                        $(obj).html('<i class="fas fa-times-circle text-danger" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = 'Check this if the visitor was turned away';
                                    }
                                    else {
                                        $(obj).html('<i class="fas fa-user text-primary" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Visitor related information";
                                    }



                                }
                                else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("NotificationType") >= 0) {

                                    $(obj).html('<i class="fas fa-stream text-primary" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');

                                    if (siteType == 0) {
                                        tooltipText = "Select what notification shall be sent for this check in. If automatic, VisitForm will send a notification depending on what the resident has opted for";
                                    }
                                    else {
                                        tooltipText = "Select what notification shall be sent for this check in. If automatic, VisitForm will send a notification depending on what the host has opted for";
                                    }



                                }

                                else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("Vendor") >= 0) {

                                    if (cid.indexOf("VendorName") >= 0) {
                                        $(obj).html('<i class="fas fa-user-tag text-primary" style="color:#FB8C00 !important; font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Vendor name, this field automatically fills the other vendor fields when a vendor is selected in this dropdown";
                                    }
                                    else {
                                        $(obj).html('<i class="fas fa-user-tag text-primary" style="color:#FB8C00 !important; font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Vendor related information";
                                    }



                                }

                                else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("ExpectedCheckinTimestamp") >= 0) {

                                    if (gridIndex == 4) {
                                        //title = 'Start';
                                        $(obj).html('<i class="fas fa-clock text-primary" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        //tooltipText = "Start";
                                    }
                                    else {
                                        $(obj).html('<i class="fas fa-clock text-primary" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Expected arrival time";
                                    }
                                }
                                else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("ExpectedCheckoutTimestamp") >= 0) {

                                    if (gridIndex == 4) {
                                        //title = 'End';
                                        $(obj).html('<i class="fas fa-clock text-primary" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        //tooltipText = "End";
                                    }
                                    else {
                                        $(obj).html('<i class="fas fa-clock text-primary" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Expected departure time";
                                    }
                                }
                                else if (guardScreenCheckinSpreadsheetColumns[gridIndex][cx].name.indexOf("VisitTypeCategoryName") >= 0) {

                                    if (gridIndex == 4) {
                                        title = 'Event Type';
                                        $(obj).html('<i class="fas fa-exclamation-triangle text-danger" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Event Type";
                                    }
                                    else {
                                        $(obj).html('<i class="fas fa-exclamation-triangle text-danger" style="font-size:100%;padding-right:5px;"></i><span>' + title + '</span>');
                                        tooltipText = "Event Type";
                                    }
                                }

                                //try {
                                //    tippy(obj, {
                                //        content: tooltipText,
                                //        delay: 500
                                //    });
                                //} catch (e) {

                                //}


                            }
                        }


                    });
                }
            } catch (e) {

            }



            //Make ReceiverUnit column title bold
            $($(instance).find('td[data-x="' + receiverUnitColumnIndex + '"]')).each(function (i, obj) {
                if (i == 0) {


                    $(obj).css("font-weight", "bold");
                }
            });

            //Make ReceiverUnit column title bold
            $($(instance).find('td[data-x="' + vendorNameColumnIndex + '"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            //Make AutoAdmit column title bold
            $($(instance).find('td[data-x="' + autoAdmitColumnIndex + '"]')).each(function (i, obj) {
                if (i == 0) {
                    $(obj).css("font-weight", "bold");
                }
            });

            //Expected Checkout

            if (gridIndex == 4 || gridIndex == 8) {

                const alpha = Array.from(Array(26)).map((e, i) => i + 65);
                const alphabet = alpha.map((x) => String.fromCharCode(x));

                $($(instance).find('td[data-x="' + expectedCheckoutColumnIndex + '"]')).each(function (i, obj) {

                    if (i != 0) {


                        try {
                            var expectedCheckoutData = guardScreenCheckinSpreadsheet[gridIndex].getRowData(i)[expectedCheckoutColumnIndex];
                            var expectedCheckoutTime = new Date(expectedCheckoutData);






                            if (expectedCheckoutTime < guardScreenClockTickTimer) {




                                guardScreenCheckinSpreadsheet[gridIndex].setStyle(alphabet[expectedCheckoutColumnIndex] + (i + 1), 'color', 'red');

                                //$(obj).css("color", "red");

                            }

                        } catch { }


                    }
                });
            }
        },

        onselection: function (instance) {
            var t = guardScreenCheckinSpreadsheet[gridIndex].getSelectedColumns(true);
            var r = guardScreenCheckinSpreadsheet[gridIndex].getSelectedRows(true);
            var checkoutColumnIndex = columnCount;
            //Stop the selection if user selects checkin timestamp or checkout button cols
            if (t != null && (t.indexOf(checkoutColumnIndex) >= 0 || t.indexOf(1) >= 0)) {
                guardScreenCheckinSpreadsheet[gridIndex].resetSelection(false);
            }
            if (Number(t[0]) == 1 && FirstCellMoved) {
                MoveToCell(Number(r[0]), (Number(t[0]) + 1), true);
            }
            if (Number(t[0]) == columnCount && FirstCellMoved) {
                MoveToCell(Number(r[0]), (Number(t[0]) - 1), true);
            }
            //if (t[0] == 1) {
            //    MoveToCell(0,-1)
            //}

            //contenu from here
            //console.log(instance.jexcel)
        },
        onchange: async function (obj, cel, val) {


            // Used to avoid onchange event to propagate
            if (guardScreenCheckinSpreadsheetOnChangeDisabled) {
                return;
            }

            var checkinId = 0;
            var newValue = "";
            var columnToUpdate = "";

            var columnsInHeader = guardScreenCheckinSpreadsheetColumns[gridIndex];


            //Grid coordinates of data just updated

            var x = 0;
            var y = 0;

            try {
                x = parseInt($(cel).attr("data-x"));
            }
            catch (e) {
                //console.log(e);
            }

            if (isNaN(x)) {
                return;
            }

            try {
                y = parseInt($(cel).attr("data-y"));
            }
            catch (e) {
                //console.log(e);
            }

            //This is the name of the column that user just updated
            try {
                columnToUpdate = columnsInHeader[x].name;
            } catch (e) {

            }



            //We changed something in the first row / check in row
            if (y == 0) {

                //Check if the column we changed belongs to the Receiver data information
                if (columnToUpdate.indexOf("Receiver") >= 0) {
                    //Get the ID of Receiver data changed

                    var receiverLookedUp = null;
                    var personsLookedUp = null;
                    //Get the string value of the data we just changed
                    var dataChangedValue = guardScreenCheckinSpreadsheet[gridIndex].getRowData(y)[val];



                    var personEmail = null;
                    var personPhone = null;
                    var personPhone2 = null;
                    var personPhone3 = null;
                    var personName = null;

                    var receiverNameChosen = guardScreenCheckinSpreadsheet[gridIndex].getRowData(y)[receiverNameColumnIndex];
                    var receiverUnitChosen = guardScreenCheckinSpreadsheet[gridIndex].getRowData(y)[receiverUnitColumnIndex];

                    if (receiverLookedUp == null) {

                        //Search through receivers that has a property with that data value
                        //for (var i = 0; i < receiversCache.length; i++) {
                        //    if (receiversCache[i][minimizeFirstLetter(columnToUpdate)] == dataChangedValue) {
                        //        receiverLookedUp = receiversCache[i];

                        //        personPhone = receiversCache[i].receiverPhonenumber;
                        //    }
                        //}



                        var receiverLookedUpPromise = DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'GetReceiverFromGrid', 'ReceiverUnit', dataChangedValue)
                            .then(r => { return r; });
                        var receiverLookedUp = await receiverLookedUpPromise;


                        // receiverLookedUp = DotNet.invokeMethod('VisitForm.Client.UI.Guard', 'GetReceiverFromGrid', 'ReceiverUnit', dataChangedValue)

                    }

                    if (receiverLookedUp != null) {
                        personPhone = receiverLookedUp.receiverPhonenumber;
                        personPhone2 = receiverLookedUp.receiverPhonenumber2;
                        personPhone3 = receiverLookedUp.receiverPhonenumber3;
                    }


                    if (columnToUpdate == "ReceiverName") {

                        var receiverWithResidentPromise = DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'GetReceiverForPersonFromGrid', receiverNameChosen)
                            .then(r => { return r; });
                        var receiverWithResident = await receiverWithResidentPromise;

                        //var receiverWithResident = personCacheGetReceiverFromResidentName(receiverNameChosen);

                        var receiverChosen = null;
                        var personChosen = null;

                        if (receiverWithResident != null) {
                            receiverChosen = receiverWithResident.receiver;
                            personChosen = receiverWithResident.person;

                            receiverLookedUp = receiverChosen;

                        }




                        if (receiverChosen != null) {
                            receiverUnitChosen = receiverChosen.receiverUnit;
                            if (receiverChosen.receiverIsRental) {
                                receiverNameChosen = receiverChosen.receiverName;
                            }
                        }



                        if (personChosen != null) {
                            personPhone = personChosen.personPhonenumber;
                            personPhone2 = personChosen.personPhonenumberTwo;
                            personPhone3 = personChosen.personPhonenumberThree;
                        }
                    }

                    personName = receiverNameChosen;


                    //lastReceiverLookedUpCache[gridIndex] = receiverLookedUp;

                    for (var i = 0; i < columnCount; i++) {
                        // Find columns in grid that we can update with Receiver lookup data
                        if ((guardScreenCheckinSpreadsheetColumns[gridIndex][i].name).indexOf("Receiver") >= 0 && guardScreenCheckinSpreadsheetColumns[gridIndex][i].name != columnToUpdate) {
                            var columnX = i;

                            // Dont propagate onchange events
                            guardScreenCheckinSpreadsheetOnChangeDisabled = true;

                            var columnValue = "";

                            if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "ReceiverName") {
                                columnValue = personName;
                            }
                            if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "ReceiverPhonenumber") {
                                columnValue = personPhone;
                                DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'ShowPhonePopup', personPhone);
                            }
                            else if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "ReceiverPhonenumber2") {
                                columnValue = personPhone2 == null ? "" : personPhone2;
                            }
                            else if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "ReceiverPhonenumber3") {
                                columnValue = personPhone3 == null ? "" : personPhone3;
                            }
                            else if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "ReceiverEmail") {
                                columnValue = personEmail;
                            }
                            else {
                                if (receiverLookedUp != null) {
                                    columnValue = receiverLookedUp[minimizeFirstLetter(guardScreenCheckinSpreadsheetColumns[gridIndex][i].name)];
                                }
                            }



                            // Set internal value TODO?
                            guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(columnX, 0, columnValue, true);

                            $($('#' + guardScreenCheckinSpreadsheetElement).find('td[data-x][data-y="0"]')).each(function (i, obj) {
                                //Set visual value, since we are using a custom dropdow. Setting the internal data wont update the visual data for some reason
                                if (i == columnX) {

                                    if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "ReceiverRequireCall") {
                                        columnValue = columnValue ? "yes" : "no";
                                    }

                                    $(obj).html(columnValue);
                                }
                            });

                            guardScreenCheckinSpreadsheetOnChangeDisabled = false;
                        }

                        if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == 'VisitNotificationType' && guardScreenCheckinSpreadsheetColumns[gridIndex][i].name != columnToUpdate && receiverLookedUp != null) {
                            var columnX = i;

                            // Dont propagate onchange events
                            guardScreenCheckinSpreadsheetOnChangeDisabled = true;

                            // Fetch data from looked up receiver
                            var columnValue = receiverLookedUp.receiverNotifyBy > 0 ? "Automatic" : "";

                            // Set internal value

                            guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(columnX, 0, columnValue, true);

                            $($('#' + guardScreenCheckinSpreadsheetElement).find('td[data-x][data-y="0"]')).each(function (i, obj) {
                                //Set visual value, since we are using a custom dropdow. Setting the internal data wont update the visual data for some reason
                                if (i == columnX) {
                                    $(obj).html(columnValue);
                                }
                            });

                            guardScreenCheckinSpreadsheetOnChangeDisabled = false;
                        }

                        //if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == 'ReceiverUnit' && guardScreenCheckinSpreadsheetColumns[gridIndex][i].name != columnToUpdate) 
                        if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == 'ReceiverUnit') {

                            if (receiverLookedUp != null) {
                                // Fetch data from looked up receiver
                                var columnValue = receiverLookedUp.receiverUnit;


                                DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnReceiverUnitSelectedFromGrid', columnValue, 'timestamp');
                            }


                        }
                    }

                }

                //Receiver unit changed in vendor check in
                if (columnToUpdate.indexOf("ReceiverUnit") >= 0 && (gridIndex == 1 || gridIndex == 3)) {

                    var unitChanged = guardScreenCheckinSpreadsheet[gridIndex].getRowData(y)[val];

                    var allowText = '';
                    var vendorAutoAdmitFrom = null;
                    var vendorAutoAdmitTo = null;
                    var vendorAutoAdmitDue = null;




                    try {
                        var vendorAllowList = JSON.parse(lastVendorLookedUpCache.vendorReceiverAutoAllowList);

                        if (vendorAllowList != null) {
                            var vendorAllowListCount = vendorAllowList.length;

                            var unitToSearch = '';
                            try {
                                unitToSearch = unitChanged.trim().toLowerCase();

                            } catch (e) {

                            }




                            if (unitToSearch != '') {
                                for (var vx = 0; vx < vendorAllowListCount; vx++) {

                                    var currentUnitToSearchIn = "";

                                    try {
                                        var currentUnitToSearchIn = vendorAllowList[vx].ReceiverUnit.toLowerCase().trim();
                                    } catch { }


                                    if (currentUnitToSearchIn == unitToSearch) { // found unit

                                        allowText = vendorAllowList[vx].VendorAutoAdmitBanned;

                                        showVendorAutoAdmitSnackbar(vendorAllowList[vx]);

                                        vendorAutoAdmitDue = vendorAllowList[vx].VendorAutoAdmitDue;

                                        vendorAutoAdmitFrom = vendorAllowList[vx].VendorAutoAdmitDueFrom;
                                        vendorAutoAdmitTo = vendorAllowList[vx].VendorAutoAdmitDueTo;


                                        break;
                                    }
                                }
                            }

                        }


                    } catch (e) {

                    }


                    guardScreenCheckinSpreadsheetOnChangeDisabled = true;

                    $($('#' + guardScreenCheckinSpreadsheetElement).find('td[data-x][data-y="0"]')).each(function (i, obj) {

                        if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "AutoAdmitBanned") {

                            guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(i, 0, allowText, true);
                            var currentAllowText = $(obj).html();

                            if (vendorAutoAdmitDue != "Permanent" && hasAutoAdmitExpired(allowText, vendorAutoAdmitFrom, vendorAutoAdmitTo)) {
                                $(obj).html("Expired");
                                $(obj).css({ 'color': 'orange', 'font-size': '150%' });


                                //try {
                                //    var entryHelpText = timestampToUsShortColDate(autoAdmitFrom) + " - " + timestampToUsShortColDate(autoAdmitTo);
                                //    tippy(obj, {
                                //        content: "Entry: " + entryHelpText,
                                //        delay: 500
                                //    });
                                //}
                                //catch (e) { }
                            }
                            else {
                                if (currentAllowText.toLowerCase().indexOf("banned") >= 0) {
                                    $(obj).css({ 'color': 'red', 'font-size': '150%' });
                                }
                                else if (currentAllowText.toLowerCase().indexOf("allow") >= 0) {

                                    $(obj).css({ 'color': 'limegreen', 'font-size': '150%' });
                                }
                            }




                        }
                    });

                    guardScreenCheckinSpreadsheetOnChangeDisabled = false;

                }

                if (columnToUpdate.indexOf("AutoAdmitName") >= 0) {



                    var lastLookedUpAutoAdmitListPromise = DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'GetLastLookedUpAutoAdmitListFromGrid')
                        .then(r => { return r; });
                    var lastLookedUpAutoAdmitListStr = await lastLookedUpAutoAdmitListPromise;

                    // var lastLookedUpAutoAdmitListStr = DotNet.invokeMethod('VisitForm.Client.UI.Guard', 'GetLastLookedUpAutoAdmitListFromGrid')
                    try {
                        lastLookedUpAutoAdmitList = JSON.parse(lastLookedUpAutoAdmitListStr);
                    }
                    catch
                    {
                        lastLookedUpAutoAdmitList = null;
                    }

                    //Get the string value of the data we just changed
                    var dataChangedValue = guardScreenCheckinSpreadsheet[gridIndex].getRowData(y)[val];


                    var currentAutoAdmit = null;

                    try {
                        for (var acx = 0; acx < lastLookedUpAutoAdmitList.length; acx++) {
                            try {
                                if (lastLookedUpAutoAdmitList[acx].AutoAdmitType != 3) {
                                    if (dataChangedValue.toLowerCase().trimEnd() == lastLookedUpAutoAdmitList[acx].AutoAdmitName.toLowerCase().trimEnd()) {
                                        currentAutoAdmit = lastLookedUpAutoAdmitList[acx];
                                        break;
                                    }
                                }
                            }
                            catch { }
                        }
                    } catch (e) {

                    }


                    var shouldSetEmpty = false;

                    //If we didnt find any currentAutoAdmit with corresponding data, return
                    if (currentAutoAdmit == null && dataChangedValue == "") {
                        //return;

                        shouldSetEmpty = true;
                    }

                    var autoAdmitFrom = null;
                    var autoAdmitTo = null;
                    var autoAdmitDue = null;

                    try {
                        autoAdmitDue = currentAutoAdmit.AutoAdmitDue;
                        autoAdmitFrom = currentAutoAdmit.AutoAdmitDueFrom;
                        autoAdmitTo = currentAutoAdmit.AutoAdmitDueTo;
                    }
                    catch (e) {

                    }

                    showAutoAdmitSnackbar(currentAutoAdmit);

                    for (var i = 0; i < columnCount; i++) {
                        // Find columns in grid that we can update with Receiver lookup data
                        if ((guardScreenCheckinSpreadsheetColumns[gridIndex][i].name).indexOf("AutoAdmit") >= 0 && guardScreenCheckinSpreadsheetColumns[gridIndex][i].name != "AutoAdmitName") {
                            var columnX = i;

                            // Dont propagate onchange events
                            guardScreenCheckinSpreadsheetOnChangeDisabled = true;

                            var shouldChangeValue = false;

                            if (shouldSetEmpty || currentAutoAdmit != null) {
                                shouldChangeValue = true;
                            }

                            var columnValue = ' ';

                            if (!shouldSetEmpty) {
                                if (currentAutoAdmit != null) {
                                    columnValue = currentAutoAdmit[guardScreenCheckinSpreadsheetColumns[gridIndex][i].name];
                                }
                            }

                            if (shouldChangeValue) {
                                // Set internal value

                                guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(columnX, 0, columnValue == null ? "" : columnValue, true);

                                $($('#' + guardScreenCheckinSpreadsheetElement).find('td[data-x][data-y="0"]')).each(function (i, obj) {
                                    //Set visual value, since we are using a custom dropdow. Setting the internal data wont update the visual data for some reason
                                    if ((i == columnX && (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "AutoAdmitDueFrom" || guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "AutoAdmitDueTo"))) {

                                        if (columnValue == null || columnValue == "" || columnValue == " ") {
                                            $(obj).html('');
                                        } else {
                                            $(obj).html(timestampToJexcelDateShort(columnValue));
                                        }

                                    }

                                    if ((i == columnX && (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "AutoAdmitBanned"))) {

                                        var currentAllowText = $(obj).html();

                                        if (autoAdmitDue != "Permanent" && hasAutoAdmitExpired(currentAllowText, autoAdmitFrom, autoAdmitTo)) {
                                            $(obj).html("Expired");
                                            $(obj).css({ 'color': 'orange', 'font-size': '150%' });
                                            //DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', currentAllowText, 'warning');


                                            //try {
                                            //    var entryHelpText = timestampToUsShortColDate(autoAdmitFrom) + " - " + timestampToUsShortColDate(autoAdmitTo);
                                            //    tippy(obj, {
                                            //        content: "Entry: " + entryHelpText,
                                            //        delay: 500
                                            //    });
                                            //}
                                            //catch (e) { }

                                        }
                                        else {
                                            if (currentAllowText.toLowerCase().indexOf("banned") >= 0) {
                                                //  DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', currentAllowText, 'error');
                                                $(obj).css({ 'color': 'red', 'font-size': '150%' });

                                            }
                                            else if (currentAllowText.toLowerCase().indexOf("allow") >= 0) {
                                                // DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', currentAllowText, 'succes');
                                                $(obj).css({ 'color': 'limegreen', 'font-size': '150%' });


                                            }
                                        }
                                    }
                                });
                            }



                            guardScreenCheckinSpreadsheetOnChangeDisabled = false;
                        }
                    }

                }

                if (columnToUpdate.indexOf("AutoAdmitPlateNumber") >= 0) {

                    var rowData = guardScreenCheckinSpreadsheet[gridIndex].getRowData(y);
                    newValue = rowData[x];

                    DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnPlateNumberChangedFromGrid', gridIndex, columnToUpdate, newValue);

                }

                if (columnToUpdate.indexOf("VendorName") >= 0) {
                    //Get the ID of vendor data changed

                    var vendorLookedUp = null;
                    //Get the string value of the data we just changed
                    var dataChangedValue = guardScreenCheckinSpreadsheet[gridIndex].getRowData(y)[val];



                    //Search through vendors that has a property with that data value
                    for (var i = 0; i < vendorsCache.length; i++) {
                        if (vendorsCache[i][minimizeFirstLetter(columnToUpdate)] == dataChangedValue) {
                            vendorLookedUp = vendorsCache[i];
                        }
                    }

                    //If we didnt find any vendor with corresponding data, return
                    if (vendorLookedUp == null) {
                        return;
                    }

                    lastVendorLookedUpCache = vendorLookedUp;

                    for (var i = 0; i < columnCount; i++) {
                        // Find columns in grid that we can update with vendor lookup data
                        if (((guardScreenCheckinSpreadsheetColumns[gridIndex][i].name).indexOf("Vendor") >= 0 || guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "VisitorVehicleRegistrationPlate") && guardScreenCheckinSpreadsheetColumns[gridIndex][i].name != columnToUpdate && guardScreenCheckinSpreadsheetColumns[gridIndex][i].name != "VisitorIsVendor") {
                            var columnX = i;

                            // Dont propagate onchange events
                            guardScreenCheckinSpreadsheetOnChangeDisabled = true;

                            // Fetch data from looked up receiver
                            var columnValue = "";
                            try {
                                if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "VisitorVehicleRegistrationPlate") {
                                    columnValue = vendorLookedUp.vendorVehicleRegistrationPlate;
                                }
                                else {
                                    columnValue = vendorLookedUp[minimizeFirstLetter(guardScreenCheckinSpreadsheetColumns[gridIndex][i].name)];
                                }
                            } catch (e) {

                            }

                            // Set internal value
                            guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(columnX, 0, columnValue, true);

                            //$($('#' + guardScreenCheckinSpreadsheetElement).find('td[data-x][data-y="0"]')).each(function (i, obj) {
                            //    //Set visual value, since we are using a custom dropdow. Setting the internal data wont update the visual data for some reason
                            //    if (i == columnX) {
                            //        $(obj).html(columnValue);
                            //    }
                            //});

                            guardScreenCheckinSpreadsheetOnChangeDisabled = false;
                        }
                    }



                    // Auto admit column update


                    var currentUnitSelected = '';
                    $($('#' + guardScreenCheckinSpreadsheetElement).find('td[data-x][data-y="0"]')).each(function (i, obj) {

                        if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "ReceiverUnit") {

                            currentUnitSelected = guardScreenCheckinSpreadsheet[gridIndex].getRowData(y)[i];
                        }
                    });


                    var vendorNameChanged = guardScreenCheckinSpreadsheet[gridIndex].getRowData(y)[val];




                    var allowText = '';




                    try {
                        var vendorAllowList = JSON.parse(lastVendorLookedUpCache.vendorReceiverAutoAllowList);

                        if (vendorAllowList != null) {
                            var vendorAllowListCount = vendorAllowList.length;


                            var unitToSearch = '';
                            try {
                                unitToSearch = currentUnitSelected.trim().toLowerCase();
                            } catch { }



                            if (unitToSearch != '') {

                                for (var vx = 0; vx < vendorAllowListCount; vx++) {

                                    var currentUnitToSearchIn = '';

                                    try {
                                        var currentUnitToSearchIn = vendorAllowList[vx].ReceiverUnit.toLowerCase().trim();
                                    } catch { }



                                    if (currentUnitToSearchIn == unitToSearch) { // found unit

                                        allowText = vendorAllowList[vx].VendorAutoAdmitBanned;

                                        break;
                                    }
                                }


                            }

                        }



                    } catch (e) {

                    }

                    guardScreenCheckinSpreadsheetOnChangeDisabled = true;

                    $($('#' + guardScreenCheckinSpreadsheetElement).find('td[data-x][data-y="0"]')).each(function (i, obj) {

                        if (guardScreenCheckinSpreadsheetColumns[gridIndex][i].name == "AutoAdmitBanned") {


                            guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(i, 0, allowText, true);
                            var currentAllowText = $(obj).html();

                            if (currentAllowText.toLowerCase().indexOf("banned") >= 0) {
                                $(obj).css({ 'color': 'red', 'font-size': '150%' });
                                DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', currentAllowText, 'error');

                            }
                            else if (currentAllowText.toLowerCase().indexOf("allow") >= 0) {
                                $(obj).css({ 'color': 'limegreen', 'font-size': '150%' });
                                DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', currentAllowText, 'succes');
                            }


                        }
                    });

                    guardScreenCheckinSpreadsheetOnChangeDisabled = false;
                    ///////////////////////////



                }

            }
            else if (y > 0) {
                var rowData = guardScreenCheckinSpreadsheet[gridIndex].getRowData(y);

                checkinId = rowData[0];
                newValue = rowData[x];



                DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnEditVisitorCheckinFromGrid', gridIndex, parseInt(checkinId), columnToUpdate, newValue.toString());
            }

        },
        onbeforechange: function (instance, cell, x, y, value) {
            //   var cellName = jexcel.getColumnNameFromId([x, y]);

            //$('#log').append('The cell ' + cellName + ' will be changed');
        },
        onafterchange: function (instance, cell, x, y, value) {
            var cellName = jexcel.getColumnNameFromId([x, y]);

        },
        onmovecolumn: function (instance, from, to) {

            //deep copy array
            var newColumns = JSON.parse(JSON.stringify(columns));

            //swap objects by index
            newguardScreenCheckinSpreadsheetColumns[gridIndex].slice(0, from).concat(newColumns[to], newguardScreenCheckinSpreadsheetColumns[gridIndex].slice(from + 1, to), newColumns[from], newguardScreenCheckinSpreadsheetColumns[gridIndex].slice(to + 1))

            var newRequiredInputIds = [];
            var newColumnsLength = newguardScreenCheckinSpreadsheetColumns[gridIndex].length;

            for (var i = 0; i < newColumnsLength; i++) {
                if (newguardScreenCheckinSpreadsheetColumns[gridIndex][i].name != "" &&
                    newguardScreenCheckinSpreadsheetColumns[gridIndex][i].name != " " &&
                    newguardScreenCheckinSpreadsheetColumns[gridIndex][i].title != "" &&
                    newguardScreenCheckinSpreadsheetColumns[gridIndex][i].title != " " &&
                    newguardScreenCheckinSpreadsheetColumns[gridIndex][i].name != "CheckinTimestamp" &&
                    newguardScreenCheckinSpreadsheetColumns[gridIndex][i].name != "CheckoutTimestamp" &&
                    newguardScreenCheckinSpreadsheetColumns[gridIndex][i].name != "VisitNumber") {

                    newRequiredInputIds.push(newguardScreenCheckinSpreadsheetColumns[gridIndex][i].name);
                }
            }

            // alert("gridindex:" + gridIndex);
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnColumnsMovedFromGrid', newRequiredInputIds, gridIndex);
        },
        onchangeheader: function (instance, column, oldvalue, newvalue) {




            var columnId = columns[column].name;
            var newColumnFriendlyName = newvalue;

            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnColumnRenamedFromGrid', columnId, newColumnFriendlyName);
        },
        onbeforepaste: function (instance, data, x, y) {
            var selectedRow = parseInt(y);
            var selectedCol = parseInt(x);

            //var selectedRow = guardScreenCheckinSpreadsheet.getSelectedRows(true)[0];
            //var selectedCol = guardScreenCheckinSpreadsheet.getSelectedColumns(false)[0];

            //First row
            if (selectedRow == 0) {
                var inputedDataString = data;
                var endsWithNewLine = false;

                endsWithNewLine |= inputedDataString.endsWith("\r\n");
                endsWithNewLine |= inputedDataString.endsWith("\r");
                endsWithNewLine |= inputedDataString.endsWith("\n");

                if (endsWithNewLine) {

                    var nextColumnIndex = selectedCol + 1;
                    var lastColumnIndex = columnCount;

                    //Paste was done in the last editable column, focus check in button
                    if (nextColumnIndex == lastColumnIndex) {
                        $("#guardScreenGridCheckinButton" + gridIndex).focus();
                    }
                    else {
                        setTimeout(function () {
                            guardScreenCheckinSpreadsheet[gridIndex].updateSelectionFromCoords(nextColumnIndex, 0, nextColumnIndex, 0);
                        }, 500);

                    }
                }
                else {
                    //
                }


            }
        },
        onenter: function (instance) {

            $("#guardScreenGridCheckinButton" + gridIndex).focus();
            setTimeout(function () {

                // $('#gridEnterPressedVerifyModal').modal('show');


                //$("#guardScreenGridCheckinButton" + gridIndex).click();

                //setTimeout(function () {

                //    guardScreenCheckinSpreadsheet[gridIndex].updateSelectionFromCoords(2, 0, 2, 0);

                //}, 2000);

            }, 250);

        },
        onlazyload: function (instance) {

            //This function primarily used to update the last column and styles


            if (!showIndex) {
                $($(instance).find('table')).each(function (i, obj) {
                    $(obj).addClass('jexcel_hidden_index');
                });
            }

            var separatorCount = columnSeperatorIndices.length;
            for (var sx = 0; sx < separatorCount; sx++) {
                $($(instance).find('td[data-x="' + columnSeperatorIndices[sx] + '"]')).each(function (i, obj) {
                    $(obj).css("background-color", "#ccc");
                });
            }

            $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                $(obj).css("background-color", "#f3f3f3");
            });

            $($(instance).find('td[data-x="' + columnCount + '"]')).each(function (i, obj) {
                $(obj).css("background-color", "#f3f3f3");
            });


            $($(instance).find('tr')).each(function (i, obj) {
                if (i != 0 && i != 1) {
                    $(obj).addClass("guard-screen-grid-hover-row");
                }

            });


            if (evenRowsColor != "empty") {
                $($(instance).find('tr:even')).each(function (i, obj) {
                    if (i != 0) {
                        $(obj).css("background-color", evenRowsColor);
                    }
                });

                $($(instance).find('tr:odd')).each(function (i, obj) {
                    if (i != 0) {
                        $(obj).css("background-color", '#fff');
                    }

                });
            }



            //This finds all rows with columnCount, which is equal to the last column of the grid
            $($(instance).find('td[data-x="' + columnCount + '"][data-y]')).each(function (i, obj) {

                //checkinId stored in hidden column with index 0

                //var checkinId = parseInt($(instance).find('td[data-x="0"][data-y="' + i + '"]').html());
                var checkinId = parseInt($(obj).parent().children().eq(1).html());

                if (Number.isNaN(checkinId)) {
                    checkinId = 0;
                }

                //checkinTimestamp always stored in column 1
                //var checkinTimestamp = $(instance).find('td[data-x="1"][data-y="' + i + '"]').html();
                var checkinTimestamp = $(obj).parent().children().eq(2).html();

                var startRowY = 0;
                if (gridIndex == 8 || gridIndex == 9) {
                    startRowY = -1;
                }

                //Only checkout button for visitors, vendors and receivers for now
                if (gridIndex == 0 || gridIndex == 1 || gridIndex == 4 || gridIndex == 8) {
                    if (i > startRowY) {
                        var checkoutButtonLocale = 'Check Out';
                        try {
                            //checkoutButtonLocale = localeData.CheckOutButton;
                            checkoutButtonLocale = 'Check Out';
                        } catch (e) {
                            checkoutButtonLocale = 'Check Out';
                        }

                        if (gridIndex == 8) {
                            checkoutButtonLocale = 'Depart';
                        }

                        var buttonDiv = '<div style=\"display:inline-block;width:100%;display:flex;flex-direction:row;align-content:center;justify-content:center;align-items:center;\">';

                        var buttonRow = '';

                        if (checkoutRequired) {
                            buttonRow += '<button onclick=\"checkOutFromGrid(' + gridIndex + ',' + checkinId + ',\'' + checkinTimestamp + '\')\" type=\"button\" class=\"btn btn-success\">' + checkoutButtonLocale + '</button>';
                            buttonRow += '&nbsp;';
                        }

                        buttonRow += '<button onclick=\"checkinDetailsFromGrid(' + gridIndex + ',' + checkinId + ',\'' + checkinTimestamp + '\')\" type=\"button\" class=\"btn-sm btn-secondary\">' + 'Details' + '</button>';

                        buttonDiv += buttonRow;

                        buttonDiv += '</div>';

                        $(obj).html(buttonDiv);
                    }
                }


                if (gridIndex == 2 || gridIndex == 3 || gridIndex == 7 || gridIndex == 9) {


                    if (i > startRowY) {
                        var admitButtonLocale = 'Check In';
                        var admitButtonStyleClass = "btn-primary";
                        try {
                            // admitButtonLocale = localeData.CheckOutButton;
                        } catch (e) {
                            //checkoutButtonLocale = 'Check out';
                        }

                        if (gridIndex == 9) {
                            admitButtonLocale = 'Arrived';
                            admitButtonStyleClass = "btn-primary";
                        }

                        //if (gridIndex == 8) {
                        //    admitButtonLocale = 'Depart';
                        //    admitButtonStyleClass = "btn-success";
                        //}

                        var showPreCheckingButtonLocale = 'Details';


                        var admitButton = '<button onclick=\"admitPreCheckinFromGrid(' + gridIndex + ',' + checkinId + ',\'' + checkinTimestamp + '\')\" type=\"button\" class=\"screenadmitbtn btn ' + admitButtonStyleClass + '\">' + admitButtonLocale + '</button>';

                        //Lease grid
                        if (gridIndex == 8 || gridIndex == 9) {
                            var deleteButton = '<button  onclick=\"showPreCheckinDetailsFromGrid(' + checkinId + ',\'' + checkinTimestamp + '\')\" type=\"button\" class=\"btn btn-info\">' + 'Info' + '</button>';
                        }
                        else {
                            var deleteButton = '<button  onclick=\"showPreCheckinFromGrid(' + checkinId + ',\'' + checkinTimestamp + '\')\" type=\"button\" class=\"btn btn-sm btn-secondary\">' + showPreCheckingButtonLocale + '</button>';


                        }

                        var autoAdmitButtonDiv = '<div style=\"display:inline-block;width:100%;display:flex;flex-direction:row;align-content:center;justify-content:center;align-items:center;\">';
                        autoAdmitButtonDiv += admitButton + '&nbsp;' + deleteButton;
                        autoAdmitButtonDiv += '</div>';

                        $(obj).html(autoAdmitButtonDiv);

                    }
                }



            });




            ////Iterate thrught the first row
            $($(instance).find('td[data-x][data-y="0"]')).each(function (i, obj) {

                //Mark VisitNumber column gray to indicate not to fill in 
                if (visitNumberColumnIndex > 0 && i == visitNumberColumnIndex) {
                    $(obj).css("background-color", "#F3F3F3");
                }

                if (plateNumberColumnIndex > 0 && i == plateNumberColumnIndex) {
                    //   $(obj).css("text-transform", "uppercase");
                    $(obj).addClass("uppercase-typing");
                }

                //trick to have residents grid read only except for first row
                if (gridIndex == 4) {
                    $(obj).removeClass("readonly");

                }

            });


            $(".jexcel_search").css({ "border": "1px solid #ccc" });
            $(".jexcel_search").css({ "font-size": "120%" });
            $(".jexcel_search").css({ "margin-top": "20px" });


            var searchLocaleTitle = 'Search';

            //try {
            //    searchLocaleTitle = localeData.SearchButton;
            //} catch (e) {
            //    searchLocaleTitle = 'Search';
            //}





            //Expected Checkout

            if (gridIndex == 4 || gridIndex == 8) {

                const alpha = Array.from(Array(26)).map((e, i) => i + 65);
                const alphabet = alpha.map((x) => String.fromCharCode(x));

                $($(instance).find('td[data-x="' + expectedCheckoutColumnIndex + '"]')).each(function (i, obj) {

                    if (i != 0) {
                        try {
                            var expectedCheckoutData = guardScreenCheckinSpreadsheet[gridIndex].getRowData(i)[expectedCheckoutColumnIndex];
                            var expectedCheckoutTime = new Date(expectedCheckoutData);

                            if (expectedCheckoutTime < guardScreenClockTickTimer) {

                                guardScreenCheckinSpreadsheet[gridIndex].setStyle(alphabet[expectedCheckoutColumnIndex] + (i + 1), 'color', 'red');
                            }

                        } catch { }


                    }
                });
            }



        },
        onsearch: function (instance) {
        },
    });


    guardScreenCheckinSpreadsheet[gridIndex] = tempGrid;


    //guardScreenCheckinSpreadsheet.push(tempGrid);


    //Middle Mouse Horizontal Scroll Bugfix

    setTimeout(function () {

        for (var i = 0; i < 20; i++) {
            try {
                if (guardScreenCheckinSpreadsheet[i] != null) {
                    guardScreenCheckinSpreadsheet[i].updateSelectionFromCoords(2, 0, 2, 0);
                }
            } catch { }
        }
        DefaultCellSelected = true;
    }, 3000);


}








function changeNotesBoxLocation(layout) {


    try {

        switch (layout) {
            case 0:
                var notesSection = document.getElementById("notesSection");
                var grids = document.getElementsByClassName("jexcel_content");
                //for (var i = 0; i < grids.length; i++) {
                //    if (grids.length == 1) {
                //        grids[i].style.maxHeight = "65vh";
                //    }
                //    else {
                //        grids[i].style.maxHeight = "280px";
                //    }
                //}
                notesSection.style.display = "none";
                break;
            case 1:
                var gridsSection = document.getElementById("gridsSection");
                var gridsSection2 = document.getElementById("gridsSection2");
                var gridsSection3 = document.getElementById("gridsSection3");
                var notesSection = document.getElementById("notesSection");
                var grids = document.getElementsByClassName("jexcel_content");

                gridsSection.classList.add("col-10");
                gridsSection2.classList.add("col-10");
                gridsSection3.classList.add("col-10");
                notesSection.classList.add("col-2");
                //for (var i = 0; i < grids.length; i++) {
                //    if (grids.length == 1) {
                //        grids[i].style.maxHeight = "65vh";
                //    }
                //    else {
                //        grids[i].style.maxHeight = "280px";
                //    }
                //}
                notesSection.style.display = "block";
                break;
            case 2:
                var gridsSection = document.getElementById("gridsSection");
                var gridsSection2 = document.getElementById("gridsSection2");
                var gridsSection3 = document.getElementById("gridsSection3");

                var notesSection = document.getElementById("notesSection");
                var innerNotesSection = document.getElementById("innerNotesSection");
                var grids = document.getElementsByClassName("jexcel_content");

                gridsSection.classList.add("col-12");
                gridsSection2.classList.add("col-12");
                gridsSection3.classList.add("col-12");

                notesSection.classList.add("col-12");
                notesSection.style.justifyContent = "flex-end";;
                innerNotesSection.style.flexGrow = "0";
                document.getElementById("text").style.minHeight = "110px";

                notesSection.style.display = "block";

                //for (var i = 0; i < grids.length; i++) {
                //    if (grids.length == 1) {
                //        grids[i].style.maxHeight = "49vh";
                //    }
                //    else {
                //        grids[i].style.maxHeight = "200px";
                //    }
                //}
                break;
            default:
                break;
        }

    } catch (e) {


    }
    try {
        //Autoexpand notesbox
        var gridsSection = document.getElementById("text");
        autoExpand(gridsSection);

    } catch (e) {

    }



}

function calculateGenerateInputWidth(requiredInputs, isCheckoutGrid) {

    var generalInputsCount = 0;
    var checkboxInputsCount = 0;
    var visitNumberInputCount = 0;
    var dropdownInputCount = 0;
    var timestampInputCount = 0;
    var platenumberInputCount = 0;

    requiredInputs.forEach(function (arg) {
        if (arg.id != "CheckinId") {

            if (arg.id == "ReceiverName" || arg.id == "ReceiverUnit" || arg.id == "ReceiverPhonenumber" || arg.id == "ReceiverPhonenumber2" || arg.id == "ReceiverPhonenumber3" || arg.id == "ReceiverEmail") {

                dropdownInputCount++;
            }
            else if (arg.id == "VisitorIdentificationVerified") {
                checkboxInputsCount++;
            }
            else if (arg.id == "VisitorIsParcelDelivery") {
                checkboxInputsCount++;
            }
            else if (arg.id == "VisitNotified") {
                checkboxInputsCount++;
            }
            else if (arg.id == "VisitNumber") {
                visitNumberInputCount++;
            }
            else if (arg.id == "VisitorVehicleRegistrationPlate") {
                platenumberInputCount++;
            }
            else if (arg.id == "CheckinTimestamp" || arg.id == "CheckoutTimestamp") {
                timestampInputCount++;
            }
            else {
                generalInputsCount++;
            }

        }
    });



    var widthOfGridHolder = $('.guardscreen-data').width();

    var totalColumnCount = generalInputsCount + checkboxInputsCount + visitNumberInputCount + dropdownInputCount;


    widthOfGridHolder -= (checkboxInputsCount * 70);
    widthOfGridHolder -= (visitNumberInputCount * 100);

    widthOfGridHolder -= (dropdownInputCount * 200);
    widthOfGridHolder -= (platenumberInputCount * 200);
    widthOfGridHolder -= (timestampInputCount * 200);

    if (isCheckoutGrid) {
        //  widthOfGridHolder -= 130; //margins etc
    }
    else {
        widthOfGridHolder -= 200; //checkin button column
        widthOfGridHolder -= 60; //margins etc
    }


    var generalColumnWidth = 200;

    if (generalInputsCount > 0) {
        generalColumnWidth = widthOfGridHolder / generalInputsCount;
    }

    return generalColumnWidth;
}


function RefreshCheckinGrid(gridIndex, writeEmptyNewRow, visitorsInSiteData) {


    var keepFirstRow = false;

    if (gridIndex == 0) {
        keepFirstRow = true;
    }

    if (gridIndex == 1) {
        keepFirstRow = true;
    }

    if (gridIndex == 2 || gridIndex == 3) {
        keepFirstRow = true;
    }

    if (gridIndex == 4) {
        keepFirstRow = true;
    }

    if (gridIndex == 7) {


    }

    //if writeEmptyNewRow is true, this is a new checkin and not a refresh, dont save first row
    if (keepFirstRow && !writeEmptyNewRow) {
        try {
            var currentFirstRowDataEntered = guardScreenCheckinSpreadsheet[gridIndex].getRowData(0);

            var columnCount = visitorsInSiteData[0].length;

            try {
                visitorsInSiteData[0][0] = parseInt(currentFirstRowDataEntered[0]); //CheckinId
            } catch (e) { }


            for (var i = 2; i < columnCount - 2; i++) {
                try {
                    visitorsInSiteData[0][i] = currentFirstRowDataEntered[i];
                } catch { }

            }

        } catch (e) {
            return 0;
        }
    }


    if (guardScreenCheckinSpreadsheet[gridIndex] != null) {
        //console.log("setdata start gridIndex =" + gridIndex + "_" + new Date());
        guardScreenCheckinSpreadsheet[gridIndex].setData(visitorsInSiteData, !writeEmptyNewRow);
        //console.log("setdata done  gridIndex =" + gridIndex + "_" + new Date());

        visitorsInSiteData = null;

        return 1;
    } else {

        visitorsInSiteData = null;

        return 0;
    }
}

function RefreshLastColumnToolbar(gridIndex, checkinIdsAndToolbarData, columnCount) {

    var guardScreenCheckinSpreadsheetElement = guardScreenCheckinSpreadsheetElementRoot + gridIndex;







    if (checkinIdsAndToolbarData == null) {
        return;
    }

    //This finds all rows with columnCount, which is equal to the last column of the grid
    $($("#" + guardScreenCheckinSpreadsheetElement).find('td[data-x="' + columnCount + '"][data-y]')).each(function (i, obj) {


        //checkinId stored in hidden column with index 0
        var checkinId = parseInt($("#" + guardScreenCheckinSpreadsheetElement).find('td[data-x="0"][data-y="' + i + '"]').html());


        var found = false;
        for (var k = 0; k < checkinIdsAndToolbarData.length; k++) {
            if (checkinIdsAndToolbarData[k][0] == checkinId) {
                found = true;

                var imageButtonHtml = '<span onclick=\"displayCheckinImage(' + checkinId + ',\'' + checkinIdsAndToolbarData[k][1] + '\')\" class=\"guard-screen-toolbar-image-button\">';

                imageButtonHtml += '<i class="fas fa-image text-primary" style="font-size:250%;margin-left:5px;"></i><span>' + '' + '</span>';

                imageButtonHtml += '</span>';




                $(obj).children(":first").append(imageButtonHtml);


                var tooltipText = "Display image";

                //try {
                //    tippy(obj, {
                //        content: tooltipText,
                //        delay: 500
                //    });
                //} catch (e) {

                //}

                break;
            }
        }

        //if (Number.isNaN(checkinId)) {
        //    checkinId = 0;
        //}

        //  

        //checkinTimestamp always stored in column 1
        //  var checkinTimestamp = $(instance).find('td[data-x="1"][data-y="' + i + '"]').html();

        ////only used to set height of first row
        //if (i == 0) {
        //    // $(obj).html('<div style=\"height:36px;background-color:transperent;vertical-align:middle;line-height:36px;\"></div>');
        //    var checkinButtonLocale = 'Check in';
        //    try {
        //        checkinButtonLocale = localeData.CheckInButton;
        //    } catch (e) {
        //        checkinButtonLocale = 'Check in';
        //    }

        //    if (gridIndex == 2 || gridIndex == 3) {
        //        checkinButtonLocale = "Register";
        //    }

        //    var btnClass = "btn-primary";

        //    if (gridIndex == 2 || gridIndex == 3) {
        //        btnClass = "btn-info";
        //    }

        //    $(obj).html('<button id=\"guardScreenGridCheckinButton' + gridIndex + '\" onclick=\"checkInFromGrid(' + gridIndex + ", " + checkinId + ')\" type=\"button\" class=\"btn ' + btnClass + '\">&nbsp;&nbsp;' + checkinButtonLocale + '&nbsp;&nbsp;</button>');
        //    $(obj).css("background-color", "#F3F3F3");
        //}



    });

    //

}

//function GuardScreenVisitorCheckIn(arg) {
//    var data = guardScreenCheckinSpreadsheet.getJson(false);
//    
//    return data[0];
//}

function ReadFirstRowFromCheckInGrid(gridIndex, arg) {
    if (guardScreenCheckinSpreadsheet[gridIndex] != null) {
        return guardScreenCheckinSpreadsheet[gridIndex].getRowData(0);
    }

}

function InsertRowToCheckInGrid(gridIndex, checkinData) {



    if (guardScreenCheckinSpreadsheet[gridIndex] != null) {
        guardScreenCheckinSpreadsheet[gridIndex].insertRow(checkinData, 1, true);

        return 1;
    } else {
        return 0;
    }
}

function RemoveRowFromCheckInGrid(gridIndex, checkinId) {

    //var gridIndex = 0; //always check in grid

    var rowToRemove = 0;

    var guardScreenCheckinSpreadsheetElement = guardScreenCheckinSpreadsheetElementRoot + gridIndex;

    $($('#' + guardScreenCheckinSpreadsheetElement).find('td[data-x="0"]')).each(function (i, obj) {

        var currentRowCheckinId = 0;
        try {
            currentRowCheckinId = parseInt($(obj).html());
        } catch (e) {

        }

        if (currentRowCheckinId > 0) {
            if (currentRowCheckinId == checkinId) {

                var y = parseInt($(obj).attr("data-y"));
                rowToRemove = y;
            }
        }

    });

    if (rowToRemove > 0) {

        try {
            if (rowToRemove > 0) {
                guardScreenCheckinSpreadsheet[gridIndex].deleteRow(rowToRemove);
            }
            return 1;
        } catch (e) {

        }

    }

    return 0;
}





var checkinCooldown = false;
function checkInFromGrid(gridIndex, arg) {


    //prevent double check-in misclicks
    if (!checkinCooldown) {

        checkinCooldown = true;
        $("#guardScreenGridCheckinButton" + gridIndex).html('&nbsp;&nbsp;<i class=\"fas fa-spinner fa-spin\"></i> &nbsp;&nbsp;');

        setTimeout(function () {
            checkinCooldown = false;
        }, 250);

        DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnVisitorCheckinFromGrid', gridIndex);
    }
}

function checkOutFromGrid(gridIndex, checkinId, checkinTimestamp) {
    DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnVisitorCheckoutFromGrid', gridIndex, checkinId, checkinTimestamp);
}
function checkinDetailsFromGrid(gridIndex, checkinId, checkinTimestamp) {
    DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnCheckinDetailsFromGrid', gridIndex, checkinId, checkinTimestamp);
}

var admitCheckinCooldown = false;
function admitPreCheckinFromGrid(gridIndex, checkinId, checkinTimestamp) {

    //prevent double check-in misclicks
    if (!admitCheckinCooldown) {

        admitCheckinCooldown = true;

        document.querySelectorAll('.screenadmitbtn').forEach(elem => {
            elem.disabled = true;
        });


        setTimeout(function () {
            admitCheckinCooldown = false;

            document.querySelectorAll('.screenadmitbtn').forEach(elem => {
                elem.disabled = false;
            });
        }, 1);


        if (gridIndex == 9) { //ask user before starting lease
            swal({
                title: "Confirm Start Lease",
                text: " ",
                type: "info",
                showCancelButton: true,
                confirmButtonClass: "btn-primary",
                confirmButtonText: "Start",
                closeOnConfirm: true
            },
                function () {
                    DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnCheckinPreCheckinFromGrid', gridIndex, checkinId, checkinTimestamp);
                });
        }
        else if (gridIndex == 8) { //ask user before ending lease
            swal({
                title: "Confirm End Lease",
                text: " ",
                type: "info",
                showCancelButton: true,
                confirmButtonClass: "btn-success",
                confirmButtonText: "End",
                closeOnConfirm: true
            },
                function () {
                    DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnCheckinPreCheckinFromGrid', gridIndex, checkinId, checkinTimestamp);
                });
        }
        else {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnCheckinPreCheckinFromGrid', gridIndex, checkinId, checkinTimestamp);
        }
    }

}

function showPreCheckinFromGrid(checkinId, checkinTimestamp) {
    DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowPreCheckinFromGrid', checkinId, checkinTimestamp);
}

var flashMessageShowing = false;
function flashAfterCheckinMessage() {

    if (flashMessageShowing) {
        return;
    }

    $('#guard-screen-after-checkin-message').show();
    flashMessageShowing = true;
    //$('#guard-screen-after-checkin-message-flash').addClass('flash');
    //setTimeout(function () {
    //    $('#guard-screen-after-checkin-message-flash').removeClass('flash');
    //}, 500);


    setTimeout(function () {
        flashMessageShowing = false;
        $('#guard-screen-after-checkin-message').hide();
    }, 10000);
}



//Guards typeahead

var objects = [];
var map = {};
function InitGuardsTypeahead(guards) {
    const guardsRaw = [];
    for (let i = 0; i < guards.length; i++) {
        const name = guards[i].guardName;
        if (name) guardsRaw.push(name);
    }

    // optional: dedupe + sort
    const guardsList = Array.from(new Set(guardsRaw)).sort((a, b) => a.localeCompare(b));

    buildTypeahead('#guardCheckinSelect .typeahead', 'guards', guardsList);
    return true;
}

// Returns ALL data when q is empty; otherwise substring match (case-insensitive)
function substringMatcherAll(data) {
    return function findMatches(q, syncResults) {
        if (!q) { syncResults(data); return; }
        const safe = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const rx = new RegExp(safe, 'i');
        const matches = [];
        for (let i = 0; i < data.length; i++) {
            if (rx.test(data[i])) matches.push(data[i]);
        }
        syncResults(matches);
    };
}

// Normal matcher (used by non-guard typeaheads)
function substringMatcher(data) {
    return function findMatches(q, syncResults) {
        const safe = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const rx = new RegExp(safe, 'i');
        const matches = [];
        for (let i = 0; i < data.length; i++) {
            if (rx.test(data[i])) matches.push(data[i]);
        }
        syncResults(matches);
    };
}

function buildTypeahead(el, name, data) {
    try { $(el).typeahead('destroy'); } catch (e) { }

    const isGuardTA = (name === 'guards') && $(el).closest('#guardCheckinSelect').length > 0;

    const ta = $(el).typeahead(
        {
            hint: true,
            highlight: true,
            minLength: isGuardTA ? 0 : 1,  
            autoselect: false
        },
        {
            name,
            limit: isGuardTA ? 1000 : 5,
            source: isGuardTA ? substringMatcherAll(data) : substringMatcher(data)
        }
    );


    if (isGuardTA) {

        const ensureMenuStyled = () => {
            const $menu = $(el).siblings('.tt-menu');
            if ($menu.length && !$menu.hasClass('tt-menu-guards')) {
                $menu.addClass('tt-menu-guards');
            }
        };
    
        ensureMenuStyled();
        ta.on('typeahead:render', ensureMenuStyled);

        // Inject scoped style once
        if (!document.getElementById('tt-menu-guards-style')) {
            const style = document.createElement('style');
            style.id = 'tt-menu-guards-style';
            style.textContent = `
              .tt-menu.tt-menu-guards {
                max-height: 160px;  /* ~5 rows */
                overflow-y: auto;
                overflow-x: hidden;
              }
            `;
            document.head.appendChild(style);
        }

        // Open the menu on focus/click:
        // - If empty: show ALL (don’t clear anything)
        // - If there is a value: keep it (don’t wipe it)
        ta.on('focus click', function () {
            const $input = $(this);
            const cur = $input.typeahead('val').trim();
            if (cur.length === 0) {
                // empty  trigger search with empty string to show all
                $input.trigger('input');
            }
            $input.typeahead('open');
        });

        // Optional: open on ArrowDown without clearing existing value
        ta.on('keydown', function (e) {
            if (e.key === 'ArrowDown') {
                const $input = $(this);
                const cur = $input.typeahead('val').trim();
                if (cur.length === 0) {
                    $input.trigger('input');
                }
                $input.typeahead('open');
            }
        });
    }
    // ---- end guard-only special ----
}



function clearTypeahead() {
    try {
        $('#guardCheckinSelect .typeahead').typeahead('val', '');
    }
    catch (e) { }
}


function hideAllCheckinRowsExceptFirst(gridIndex, visible) {

    $($('#' + guardScreenCheckinSpreadsheetElementRoot + gridIndex).find('tr[data-y]')).each(function (i, obj) {
        if (i > 0) {
            if (visible) {
                $(obj).show();
            }
            else {
                $(obj).hide();
            }

        }
    });
}

function setCheckinLoading(gridIndex, isLoading) {

    if (isLoading) {
        $('#newVisitorArrow' + gridIndex).hide();
        $('#newVisitorArrowLoading' + gridIndex).show();
        $('#guardScreenGridCheckinButton').prop("disabled", true);
    }
    else {
        $('#newVisitorArrow' + gridIndex).show();
        $('#newVisitorArrowLoading' + gridIndex).hide();
        $('#guardScreenGridCheckinButton').prop("disabled", false);
    }
}

function openResidentsWindow(siteName, screenLink) {

    var url = 'https://localhost:5001';

    if (release) {
        url = 'https://visitform.com/app';
    }
    url += '/screen/people/' + screenLink;


    var width = screen.width - 256;
    var height = screen.height - 256;

    if (width < 256) {
        width = 256;
    }

    if (height < 256) {
        height = 256;
    }

    var left = ($(window).width() / 2) - (width / 2);
    var top = ($(window).height() / 2) - (height / 2);
    popup = window.open(url, "popup", "width=" + width + ", height =" + height + ", top=" + top + ", left=" + left);

    popup.addEventListener('load', function () {
        popup.document.title = "VisitForm | Residents - " + siteName;
    }, false);
}

function openTextingWindow(siteName, screenLink) {

    var url = 'https://localhost:5001';

    if (release) {
        url = 'https://visitform.com/app';
    }
    url += '/screen/texting/' + screenLink;


    var width = screen.width - 256;
    var height = screen.height - 256;

    if (width < 256) {
        width = 256;
    }

    if (height < 256) {
        height = 256;
    }

    var left = ($(window).width() / 2) - (width / 2);
    var top = ($(window).height() / 2) - (height / 2);
    popup = window.open(url, "popup", "width=" + width + ", height =" + height + ", top=" + top + ", left=" + left);

    popup.addEventListener('load', function () {
        popup.document.title = "VisitForm | Texting - " + siteName;
    }, false);

    setTimeout(function () {
        DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnTextingPageOpenedByUser');
    }, 3000);
}

function openTasksWindow(siteName, screenLink) {

    var url = 'https://localhost:5001';

    if (release) {
        url = 'https://visitform.com/app';
    }
    url += '/screen/tasks/' + screenLink;


    var width = screen.width - 256;
    var height = screen.height - 256;

    if (width < 256) {
        width = 256;
    }

    if (height < 256) {
        height = 256;
    }

    var left = ($(window).width() / 2) - (width / 2);
    var top = ($(window).height() / 2) - (height / 2);
    popup = window.open(url, "popup", "width=" + width + ", height =" + height + ", top=" + top + ", left=" + left);

    popup.addEventListener('load', function () {
        popup.document.title = "VisitForm | Tasks - " + siteName;
    }, false);
}

function openAwayLogWindow(siteName, screenLink) {

    var url = 'https://localhost:5001';

    if (release) {
        url = 'https://visitform.com/app';
    }
    url += '/screen/people/' + screenLink + '/2';

    var width = screen.width - 256;
    var height = screen.height - 256;

    if (width < 256) {
        width = 256;
    }

    if (height < 256) {
        height = 256;
    }

    var left = ($(window).width() / 2) - (width / 2);
    var top = ($(window).height() / 2) - (height / 2);

    popup = window.open(url, "popup", "width=" + width + ", height =" + height + ", top=" + top + ", left=" + left);

    popup.addEventListener('load', function () {
        popup.document.title = "VisitForm | Away log - " + siteName;
    }, false);


}

//function openAwayLogWindow(siteName) {

//    var url = 'https://localhost:5001/screen/people/92781376/2';
//    var width = screen.width - 128;
//    var height = screen.height - 256;

//    if (width < 128) {
//        width = 128;
//    }

//    if (height < 256) {
//        height = 256;
//    }

//    //var left = ($(window).width() / 2) - (width / 2),
//    //    top = ($(window).height() / 2) - (height / 2),
//    //    popup = window.open(url, "popup", "width=" + width + ", height =" + height + ", top=" + top + ", left=" + left);

//    $.modalLink.open(url, {
//        height: height,
//        width: width,

//    }); 
//}


function openVisitorControlWindow(tabIndex, siteName) {

    var url = 'https://localhost:5001/screen/visitorcontrol/92781376/' + tabIndex;
    var width = screen.width - 256;
    var height = screen.height - 256;

    if (width < 256) {
        width = 256;
    }

    if (height < 256) {
        height = 256;
    }

    var left = ($(window).width() / 2) - (width / 2),
        top = ($(window).height() / 2) - (height / 2),
        popup = window.open(url, "popup", "width=" + width + ", height =" + height + ", top=" + top + ", left=" + left);



    //var width = screen.width - 128;
    //var height = screen.height - 128;

    //window.open('https://localhost:5001/screen/people/92781376', siteName, "height=" + height + ",width=" + width);
}

function showReceiverRequireCall(receiverName, receiverPhone1, receiverPhone2) {
    swal({
        title: "Call required",
        text: "\n" + receiverName + " is marked to require a call before a check in\n\nPhone number:\n\n" + receiverPhone1 + "\n" + receiverPhone2 + "\n\n",
        customClass: 'swal-wide-column-tips',
    });
}


function showHeadsUpAndAnnouncementAlert(receiverUnit, receiverName, announcements, headsup, requireCall, requireCallAlert, receiverPhone1, receiverPhone2, hasPhoneNumber) {

    try {

        var messageRequireCall = receiverName + " is marked to require a call before a check in";

        if (hasPhoneNumber) {
            messageRequireCall += "<p>Phone number:</p><p>" + (receiverPhone1 != null ? receiverPhone1 : "") + "</p><p>" + (receiverPhone2 != null ? receiverPhone2 : "") + "</p>";
        }
        else {
            messageRequireCall += "<br>";
        }

        messageRequireCall += "<br>";


        var messageHeadsUp = "";

        var messageAnnouncements = "";
        var headsupCount = 0;

        if (headsup != null) {
            headsupCount = headsup.length;
            for (var i = 0; i < headsupCount; i++) {
                messageHeadsUp += headsup[i].headsUpNotes + "\n";
            }
        }


        var announcementsCount = 0;
        if (announcements != null) {
            announcementsCount = announcements.length;
            for (var ix = 0; ix < announcementsCount; ix++) {
                messageAnnouncements += announcements[ix].announcementText + "\n";
            }
        }



        if (headsupCount == 0 && announcementsCount == 0 && (!requireCall || !requireCallAlert)) {
            return 0;
        }


    } catch (e) {
        alert("Error 1: " + e);
        return 0;
    }


    try {

        var messageData = "\n" +
            (requireCall ? "<h4><strong>Call required</strong></h4>" + messageRequireCall : "") +
            (announcementsCount > 0 ? "<h4><strong>Announcements</strong></h4>" : "") + messageAnnouncements + (announcementsCount > 0 ? "\n" : "") +
            (headsupCount > 0 ? "<h4><strong>Notes</strong></h4>" : "") + messageHeadsUp + (headsupCount > 0 ? "\n" : "");

        try {
            messageData = messageData.replace(/\n/g, '<br>');
        }
        catch {

        }
        // messageData = messageData.replaceAll("\n", "<br>");

        messageData = "<div style=\"overflow-y:auto;max-height:100%;\">" + messageData + "</div>";

        swal({
            title: "Message(s)",
            html: true,
            text: messageData,
            customClass: 'swal-wide-message',
        });
    } catch (e) {
        alert("Error 2 " + e);

    }

    return 1;
}

var autoExpand = function (field) {

    // Reset field height
    field.style.height = 'inherit';

    // Get the computed styles for the element
    var computed = window.getComputedStyle(field);

    // Calculate the height
    var height = parseInt(computed.getPropertyValue('border-top-width'), 10)
        + parseInt(computed.getPropertyValue('padding-top'), 10)
        + field.scrollHeight
        + parseInt(computed.getPropertyValue('padding-bottom'), 10)
        + parseInt(computed.getPropertyValue('border-bottom-width'), 10);

    field.style.height = height + 'px';

};

document.addEventListener('input', function (event) {
    if (event.target.tagName.toLowerCase() !== 'textarea') return;
    autoExpand(event.target);

}, false);


function confirmEndShiftFromAlert(taskCount) {

    var taskWord = taskCount == 1 ? "task" : "tasks";
    var requireWord = taskCount == 1 ? "requires" : "require";

    swal({
        title: "Are you sure?",
        text: "There are " + taskCount + " " + taskWord + " which " + requireWord + " attention for current shift, are you sure you want to end the shift?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: "Yes, end shift anyway",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnEventEndShiftFromAlertByUser');
        });

}

function playNewTextSound() {
    try {


        var audio = new Audio('audio/newtext.mp3');

        if (release) {
            audio = new Audio('/app/audio/newtext.mp3');
        }

        audio.play();

    } catch (e) {

    }
}

function displayCheckinImage(checkinId, blobIdentifier) {


    DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowPhotoOpenedByUser', checkinId, blobIdentifier);
}

function openDisplayCheckinImageModal(arg) {
    $('#displayDownloadedPhoto').show();
    $('#displayAttachedPhoto').hide();

    $('#showPhotoModal').modal();
}

function closeDisplayCheckinImageModal(arg) {
    $('#displayDownloadedPhoto').hide();
    $('#displayAttachedPhoto').hide();
    $('#showPhotoModal').modal('hide');
}

function hasAutoAdmitExpired(allowText, from, to) {
    try {

        var currentTime = guardScreenClockTickTimer;

        //
        //
        //
        //
        //


        var fromDate = null;
        try {
            if (from != null && from != "") {
                fromDate = new Date(from);
                fromDate.setHours(0, 0, 0);
            }

        } catch (e) {
            fromDate = null
        }

        var toDate = null;
        try {
            if (to != null && to != "") {
                toDate = new Date(to);
                toDate.setHours(23, 59, 59);
            }

        } catch (e) {
            toDate = null;
        }



        if (fromDate == null && toDate == null) {
            return false;
        }

        if (fromDate == null && toDate != null) {

            return currentTime > toDate;
        }

        if (fromDate != null && toDate == null) {

            return currentTime < fromDate;
        }

        if (fromDate != null && toDate != null) {

            return (currentTime < fromDate) || (currentTime > toDate);
        }





    } catch (e) {

    }

    return false;
}

function getBrowserUuid() {
    try {
        var uuid = new DeviceUUID().get();
        return uuid;
    } catch (e) {
        return "";
    }
}

async function injectTextToGrid(gridIndex, column, text) {

    var columnX = -1;

    if (column == "ReceiverUnit") {
        columnX = guardScreenCheckinSpreadsheetReceiverUnitColumnIndex[gridIndex];

        try {
            lastLookedUpAutoAdmitList = [];
            // if (receiversCache != null) {
            //    receiversCacheLength = receiversCache.length;
            // for (var rx = 0; rx < receiversCacheLength; rx++) {
            // if (receiversCache[rx].receiverUnit == text) {

            //var autoAdmitsForReceiver = DotNet.invokeMethod('VisitForm.Client.UI.Guard', 'GetAutoAdmitListForReceiverFromGrid', gridIndex, unit);
            //var lastLookedUpAutoAdmitListStr = DotNet.invokeMethod('VisitForm.Client.UI.Guard', 'GetLastLookedUpAutoAdmitListFromGrid')
            //lastLookedUpAutoAdmitList = JSON.parse(lastLookedUpAutoAdmitListStr);

            var lastLookedUpAutoAdmitListPromise = DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'GetLastLookedUpAutoAdmitListFromGrid')
                .then(r => { return r; });
            var lastLookedUpAutoAdmitListStr = await lastLookedUpAutoAdmitListPromise;

            // var lastLookedUpAutoAdmitListStr = DotNet.invokeMethod('VisitForm.Client.UI.Guard', 'GetLastLookedUpAutoAdmitListFromGrid')
            lastLookedUpAutoAdmitList = JSON.parse(lastLookedUpAutoAdmitListStr);

            //lastLookedUpAutoAdmitList.push(JSON.parse(receiversCache[rx].receiverAllowList));
            //lastLookedUpAutoAdmitList = lastLookedUpAutoAdmitList[0];

            //  break;
            // }
            // }
            // }
        }
        catch (e) { }


    } else if (column == "ReceiverName") {
        columnX = guardScreenCheckinSpreadsheetReceiverNameColumnIndex[gridIndex];
    }
    else if (column == "AutoAdmitName") {
        columnX = guardScreenCheckinSpreadsheetAutoAdmitNameColumnIndex[gridIndex];
    }
    else if (column == "CheckinId") {
        columnX = 0;
    }

    //var columnCount = guardScreenCheckinSpreadsheetColumns[gridIndex].length;


    //for (var i = 0; i < columnCount; i++) {
    //    if ((guardScreenCheckinSpreadsheetColumns[gridIndex][i].name).indexOf("ReceiverUnit") >= 0) {
    //        var unit = guardScreenCheckinSpreadsheet[gridIndex].getRowData(0)[i];


    //    }
    //}




    if (columnX >= 0) {

        // guardScreenCheckinSpreadsheetOnChangeDisabled = true;
        guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(columnX, 0, text, false);
        //guardScreenCheckinSpreadsheetOnChangeDisabled = false;

        var guardScreenCheckinSpreadsheetElement = guardScreenCheckinSpreadsheetElementRoot + gridIndex;

        //
        var el = $($('#' + guardScreenCheckinSpreadsheetElement).find('td[data-x="' + columnX + '"][data-y="0"]'))[0];

        guardScreenCheckinSpreadsheet[gridIndex].dispatch('onchange', el, text);



        //DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', "Selected " + text, 'info');
    }


}

function showAutoAdmitSnackbar(autoAdmitObject) {

    if (autoAdmitObject == null) {
        return;
    }

    var currentAllowText = autoAdmitObject.AutoAdmitBanned;

    var autoAdmitFrom = autoAdmitObject.AutoAdmitDueFrom;
    var autoAdmitTo = autoAdmitObject.AutoAdmitDueTo;
    var autoAdmitDue = autoAdmitObject.AutoAdmitDue;

    var autoAdmitName = "";
    try {
        autoAdmitName = autoAdmitObject.AutoAdmitName;
    }
    catch { }

    currentAllowText = currentAllowText + ": " + autoAdmitName;


    if (autoAdmitDue != "Permanent" && hasAutoAdmitExpired(currentAllowText, autoAdmitFrom, autoAdmitTo)) {
        DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', currentAllowText, 'warning');
    }
    else {
        if (currentAllowText.toLowerCase().indexOf("allow") >= 0) {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', currentAllowText, 'success');
        }
        else if (currentAllowText.toLowerCase().indexOf("banned") >= 0) {

            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', currentAllowText, 'error');
        }
    }
}

function showVendorAutoAdmitSnackbar(autoAdmitObject) {

    if (autoAdmitObject == null) {
        return;
    }

    var currentAllowText = autoAdmitObject.VendorAutoAdmitBanned;

    var vendorAutoAdmitFrom = autoAdmitObject.VendorAutoAdmitDueFrom;
    var vendorAutoAdmitTo = autoAdmitObject.VendorAutoAdmitDueTo;
    var vendorAutoAdmitDue = autoAdmitObject.VendorAutoAdmitDue;

    //var vendorName = "";
    //try {
    //    autoAdmitName = autoAdmitObject.;
    //}
    //catch { }

    currentAllowText = autoAdmitName + " " + currentAllowText;

    if (vendorAutoAdmitDue != "Permanent" && hasAutoAdmitExpired(currentAllowText, vendorAutoAdmitFrom, vendorAutoAdmitTo)) {
        DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', currentAllowText, 'warning');
    }
    else {
        if (currentAllowText.toLowerCase().indexOf("allow") >= 0) {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', currentAllowText, 'success');
        }
        else if (currentAllowText.toLowerCase().indexOf("banned") >= 0) {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowGuardScreenSnackbar', currentAllowText, 'error');
        }
    }
}


function toggleFullscreenGuardScreen() {
    toggleFullScreen(document.body);
}

function showPreCheckinDetailsFromGrid(checkinId, checkinTimestamp) {

    DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'OnShowLeaseDetailsFromGrid', checkinId, checkinTimestamp);


}


//var firstRowCache = null;
//function cacheFirstRow(gridIndex) {
//    try {
//        firstRowCache = guardScreenCheckinSpreadsheet[gridIndex].getRowData(0);
//    } catch (e) {
//        return 0;
//    }
//    return 1;
//}

//function writeFirstRowCache(gridIndex) {

//    if (firstRowCache == null) {
//        return 0;
//    }

//   // var columnCountForGrid = guardScreenCheckinSpreadsheetColumnCount[gridIndex];

//    guardScreenCheckinSpreadsheetOnChangeDisabled = true;

//    var rowDataCount = firstRowCache.length;




//    for (var i = 2; i < rowDataCount - 2; i++) {
//        try {
//            guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(i, 0, firstRowCache[i], true);
//        } catch { }

//    }

//    guardScreenCheckinSpreadsheetOnChangeDisabled = false;

//    return 1;
//}


function clearGridFirstRow(gridIndex, force) {

    if (force) {

        var columnCountForGrid = guardScreenCheckinSpreadsheetColumnCount[gridIndex];
        guardScreenCheckinSpreadsheetOnChangeDisabled = true;
        for (var i = 2; i < columnCountForGrid; i++) {
            guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(i, 0, "", true);
        }

        guardScreenCheckinSpreadsheetOnChangeDisabled = false;

    }
    else {
        swal({
            title: "Clear row?",
            text: " ",
            type: "info",
            showCancelButton: true,
            confirmButtonClass: "btn-primary",
            confirmButtonText: "Yes",
            closeOnConfirm: true
        },
            function () {

                var columnCountForGrid = guardScreenCheckinSpreadsheetColumnCount[gridIndex];
                guardScreenCheckinSpreadsheetOnChangeDisabled = true;
                for (var i = 2; i < columnCountForGrid; i++) {
                    guardScreenCheckinSpreadsheet[gridIndex].setValueFromCoords(i, 0, "", true);
                }

                guardScreenCheckinSpreadsheetOnChangeDisabled = false;
            });
    }

}

function dispatchOnLoadCheckinTable(gridIndex) {
    setTimeout(function () {
        var guardScreenCheckinSpreadsheetElement = guardScreenCheckinSpreadsheetElementRoot + gridIndex;
        guardScreenCheckinSpreadsheet[gridIndex].dispatch('onload', document.getElementById(guardScreenCheckinSpreadsheetElement));
    }, 100);
}


function toggleGuardScreenToolbar(mode) {
    if (!mode) {
        $('#guardScreenTopBulletinToolbar').hide();
        $('#guardScreenTopToolbar1').hide();
        $('#guardScreenTopToolbar2').hide();

        $('#guardFooterMain').css('display', 'none');
    }
    else {
        $('#guardScreenTopBulletinToolbar').show();
        $('#guardScreenTopToolbar1').show();
        $('#guardScreenTopToolbar2').show();

        $('#guardFooterMain').css('display', 'flex');
    }
}

$(function () {
    $(document).on('keydown keyup input click', function (e) {
        if ($('#gridEnterPressedVerifyModal').is(':visible')) {

            $('#gridEnterPressedVerifyModal').focus();
            var key = e.which;

            if (key == 13) { //This is an ENTER 
                //$('#changed_dp_ok').click();
            }
            e.preventDefault();
            e.stopPropagation();
        }
    });

    //$(document).on('resize', function (e) {
    //    var orientationMode = getOrientationMode();
    //    alert("orientationMode: " + orientationMode);
    //});

    // Orientation Mode Handling Start

    $(window).on("resize", function () {
        try {
            var orientationMode = getOrientationMode();
            DotNet.invokeMethod('VisitForm.Client.UI.Guard', 'OnSetOrientationMode', orientationMode);
        }
        catch { }
    });


    // Orientation Mode Handling End


    //window.addEventListener('resize', (event) => {
    //    // if current/available height ratio is small enough, virtual keyboard is probably visible
    //    try {
    //        const isKeyboardHidden = ((window.innerHeight / window.screen.availHeight) > 0.6);

    //        if (!isKeyboardHidden) {
    //            $('#guardScreenTopToolbar1').hide();
    //            $('#guardScreenTopToolbar2').hide();
    //        }
    //        else {
    //            $('#guardScreenTopToolbar1').show();
    //            $('#guardScreenTopToolbar2').show();
    //        }
    //        
    //        
    //        
    //    } catch (e) {

    //    }
    //});

});

//0 - landscape, 1 - portrait
function getOrientationMode() {
    if (screen.availHeight > screen.availWidth) {
        return 1;
    }
    return 0;
}


async function triggerCheckinsToGrid(gridIndex, writeEmptyNewRow) {
    await DotNet.invokeMethodAsync('VisitForm.Client.UI.Guard', 'FetchCheckinsFromComponent', gridIndex).then((value) => {
        RefreshCheckinGrid(gridIndex, writeEmptyNewRow, value);
        value = null;
        return 1;
    });
    return 1;
}

function updateClockDispay(date, time) {
    try {
        const dateElement = document.getElementById("CurrentLocalTimeDisplayStringDate");
        const separatorElement = document.getElementById("CurrentLocalTimeDisplayStringSeparator");
        const timeElement = document.getElementById("CurrentLocalTimeDisplayStringTime");

        dateElement.innerHTML = date || "";
        timeElement.innerHTML = time || "";

        if (date && time) {
            separatorElement.innerHTML = "&nbsp;|&nbsp;";
        }
        else {
            separatorElement.innerHTML = "";
        }
    }
    catch (e) { }
}

var logConsoleEvents = true;

var _log = console.log,
    _warn = console.warn,
    _error = console.error;

if (logConsoleEvents) {
    console.error = function () {
        var stringData = JSON.stringify({ method: 'error', arguments: arguments });
        sendConsoleEvent(stringData);
        return _error.apply(console, arguments);
    };

    console.warn = function () {
        var stringData = JSON.stringify({ method: 'warn', arguments: arguments });
        sendConsoleEvent(stringData);
        return _warn.apply(console, arguments);
    };
}

function sendConsoleEvent(eventData) {

    try {
        var transferObject = {
            Name: "VisitForm Console",
            TargetName: (new Date()).toISOString(),
            Extra: eventData
        }

        var baseUrl = "https://visitform.com/logsrv";
        var url = baseUrl + "/DeviceLog/WriteDeviceLog";

        var xhttp = new XMLHttpRequest();
        xhttp.open("POST", url, true);
        xhttp.setRequestHeader('Accept', 'text/plain');
        xhttp.setRequestHeader('Content-type', 'application/json');
        //xhttp.onreadystatechange = function () {
        //    if (this.readyState == XMLHttpRequest.DONE) {
        //        if (this.status == 200) {
        //            try {
        //                var response = this.responseText;
        //            }
        //            catch (e) {

        //            }
        //        }
        //        else {
        //        }
        //    }

        //};
        xhttp.send(JSON.stringify(transferObject));
    }
    catch (e) {

    }

}

function setOpenGateCheckbox(gridIndex, status) {
    document.getElementById('checkinGridOpenGate' + gridIndex).checked = status;
}

function getOpenGateCheckbox(gridIndex) {
    return document.getElementById('checkinGridOpenGate' + gridIndex).checked;
}

function focusGuardSignInField() {
    try {
        setTimeout(function () {
            $('#guardNameSelect').focus();
        }, 250);
    }
    catch (e) { }
}

function PrintMailItemLocationReport(arg1) {
    try {
        var element = document.getElementById('mailitemlocationreportprintdata');
        var orientation = 'portrait';

        // Define basic settings to match A4 size
        var jsPDF = {
            unit: 'mm',
            format: 'a4', // Standard A4 size
            orientation: orientation,
            compress: true,  // Enable compression to keep file size smaller
            dpi: 300, // Set a higher DPI for better quality (300 DPI is standard print resolution)
        };

        var html2canvas = {
            logging: true,
            allowTaint: true,
            async: true,
            scale: 2, // Increase the scale for sharper resolution
        };

        var opt = {
            image: {
                type: 'jpeg',
                quality: 1.0, // Set quality to 1.0 for the best possible image quality
            },
            html2canvas: html2canvas,
            jsPDF: jsPDF
        };

        // Generate PDF as a Blob without downloading
        html2pdf().set(opt).from(element).toPdf().output('blob').then((pdfBlob) => {
            // Create a Blob URL and pass it to printJS
            var pdfUrl = URL.createObjectURL(pdfBlob);
            printJS({
                printable: pdfUrl,
                type: 'pdf',
                onPrintDialogClose: () => URL.revokeObjectURL(pdfUrl) // Clean up Blob URL after printing
            });

            //  printJS({ printable: pdfUrl, type: 'pdf', style: ['@page { size: A4; margin: 0mm;} body {margin: 0;} h4 {margin:0}'], targetStyles: ['*'] });
        });
    } catch (e) {
        alert(e);
        return null;
    }

}

// Print Functions Start

function PrintA4(elname, loadcontainer, loadel, printbtnel, donetext) {
    try {
        var element = document.getElementById(elname);
        var orientation = 'portrait';

        // Define basic settings to match A4 size
        var jsPDF = {
            unit: 'mm',
            format: 'a4', // Standard A4 size
            orientation: orientation,
            compress: true,  // Enable compression to keep file size smaller
            dpi: 300, // Set a higher DPI for better quality (300 DPI is standard print resolution)
        };

        var html2canvas = {
            logging: true,
            allowTaint: true,
            async: true,
            scale: 2, // Increase the scale for sharper resolution
        };

        var opt = {
            margin: [10, 0, 10, 0],
            image: {
                type: 'jpeg',
                quality: 1.0, // Set quality to 1.0 for the best possible image quality
            },
            html2canvas: html2canvas,
            jsPDF: jsPDF
        };

        // Generate PDF as a Blob without downloading
        html2pdf().set(opt).from(element).toPdf().output('blob').then((pdfBlob) => {
            // Create a Blob URL and pass it to printJS
            var pdfUrl = URL.createObjectURL(pdfBlob);
            printJS({
                printable: pdfUrl,
                type: 'pdf',
                onPrintDialogClose: () => URL.revokeObjectURL(pdfUrl) // Clean up Blob URL after printing
            });

            try {
                $('#' + loadcontainer).hide();
            }
            catch (e) { }

            try {
                document.getElementById(loadel).innerHTML = donetext;
            }
            catch (e) { }

            try {
                document.getElementById(printbtnel).disabled = false;
            }
            catch (e) { }

            //  printJS({ printable: pdfUrl, type: 'pdf', style: ['@page { size: A4; margin: 0mm;} body {margin: 0;} h4 {margin:0}'], targetStyles: ['*'] });
        });
    } catch (e) {

        try {
            $('#' + loadcontainer).hide();
        }
        catch (e) { }

        try {
            document.getElementById(loadel).innerHTML = donetext;
        }
        catch (e) { }

        try {
            document.getElementById(printbtnel).disabled = false;
        }
        catch (e) { }

    }

}

function PrintA4AndShow(elname, loadcontainer, loadel, printbtnel, donetextt) {
    try {
        var element = document.getElementById(elname);

        var jsPDF = {
            unit: 'mm',
            format: 'a4',
            orientation: 'portrait',
            compress: true,
            dpi: 300,
        };

        var html2canvas = {
            logging: true,
            allowTaint: true,
            async: true,
            scale: 2,
        };

        var opt = {
            image: {
                type: 'jpeg',
                quality: 1.0,
            },
            html2canvas: html2canvas,
            jsPDF: jsPDF
        };

        html2pdf().set(opt).from(element).toPdf().get('pdf').then((pdf) => {
            pdf.autoPrint(); // Automatically opens the print dialog
            pdf.addPage(); // Ensures the page is recognized correctly by the printer
            window.open(pdf.output('bloburl'), '_blank'); // Opens in a new tab with proper format
            try {
                $('#' + loadcontainer).hide();
            }
            catch (e) { }

            try {
                document.getElementById(loadel).innerHTML = donetext;
            }
            catch (e) { }

            try {
                document.getElementById(printbtnel).disabled = false;
            }
            catch (e) { }
        });
    } catch (e) {

        try {
            $('#' + loadcontainer).hide();
        }
        catch (e) { }

        try {
            document.getElementById(loadel).innerHTML = donetext;
        }
        catch (e) { }

        try {
            document.getElementById(printbtnel).disabled = false;
        }
        catch (e) { }
    }

}

// Print Functions End

var currFFZoom = 1;
var currIEZoom = 100;

function zoomIn() {
    var step = 2;
    currIEZoom += step;
    $('body').css('zoom', ' ' + currIEZoom + '%');
    return currIEZoom;
}

function zoomOut() {
    var step = 2;
    currIEZoom -= step;
    $('body').css('zoom', ' ' + currIEZoom + '%');
    return currIEZoom;
}

function setZoom(zoom) {
    currIEZoom = zoom;
    $('body').css('zoom', ' ' + currIEZoom + '%');
    return currIEZoom;
}

function checkOnlineStatus() {
    return navigator.onLine;
}

function isTouchTablet() {
    const ua = navigator.userAgent || '';
    const maxTouch = navigator.maxTouchPoints || 0;
    const hasTouch = ('ontouchstart' in window) || maxTouch > 0;

    const isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);

    const isIPad =
        /\b(iPad)\b/.test(ua) ||
        (navigator.platform === 'MacIntel' && maxTouch > 1);

    const isWindows =
        /Windows/.test(ua) && hasTouch;

    const minSide = Math.min(screen.width, screen.height);
    const isTabletSized = minSide >= 600;

    if ((isAndroidTablet || isIPad) && hasTouch && isTabletSized) {
        return true;
    }
    if (isWindows && isTabletSized) {
        return true;
    }
    return false;
}

function clearQueryString() {
    const url = new URL(window.location.href);
    url.search = ""; // remove ?mode=demo etc.
    window.history.replaceState({}, document.title, url.toString());
}

// Web Share API, the browser side of IShareService (see ModulesA ShareServiceWeb.cs). The native
// apps use the platform share sheet instead, so these only run in a browser.
function GuardScreenCanShare() {
    return typeof navigator !== "undefined" && typeof navigator.share === "function";
}

async function GuardScreenShare(url, text, title) {
    if (!GuardScreenCanShare()) {
        return false;
    }

    // The share sheet rejects the whole call on an empty member, so only pass what we have.
    var data = {};

    if (title) {
        data.title = title;
    }

    if (text) {
        data.text = text;
    }

    if (url) {
        data.url = url;
    }

    if (Object.keys(data).length === 0) {
        return false;
    }

    try {
        await navigator.share(data);
        return true;
    }
    catch (e) {
        // AbortError only means the user closed the share sheet, so it is not worth logging.
        if (!e || e.name !== "AbortError") {
            console.log("share error", e);
        }

        return false;
    }
}
